/* eslint-disable no-inner-declarations */
import React, { useState, useEffect } from "react";
import axios from "axios";

import DetectClientInfo from "../../Utils/DetectClientInfo.js";

import useAllCollections from "../../Hooks/useAllCollections.js";

import ResultsWrapper from "./ResultsWrapper.js";

import { useTheme } from "@mui/material/styles";

import { Button, Dialog, DialogActions, DialogContentText, Typography, CircularProgress, Divider } from "@mui/material";

import ArrowDownwardRoundedIcon from "@mui/icons-material/ArrowDownwardRounded";
import ArrowUpwardRoundedIcon from "@mui/icons-material/ArrowUpwardRounded";
import CallMissedOutgoingRoundedIcon from "@mui/icons-material/CallMissedOutgoingRounded";
import KeyboardReturnIcon from "@mui/icons-material/KeyboardReturn";

import useGlobal from "../../GlobalState/Store/Store.js";

import { useParams, useNavigate } from "react-router-dom";
import { paramCase } from "change-case";

import ShadowScrollbars from "../ShadowScrollbars.js";

import SearchBar from "../Search/SearchBar.js";

import { useHotkeys } from "react-hotkeys-hook";

import { matchSorter } from "match-sorter";
import HotkeyChip from "../Hotkey/HotkeyChip.js";
import PlainSnackBar from "../Notistack/PlainSnackBar.js";
import { useSnackbar } from "notistack";
import useEncodeCollectionURL from "../../Hooks/useEncodeCollectionURL.js";

const exampleData = {
  workspaces: [
    {
      _id: "61abb43c5577261668b49c58",
      icon: {
        emoticons: [],
        short_names: [],
      },
      name: "December Babbyyy",
      userId: "619a9ae92f709e693cdc9d82",
      indexPosition: 0,
      createdOn: "2021-12-04T18:32:28.953Z",
      collectionProperties: [
        {
          _id: "61ad79abfa4c7b40b81fa227",
          type: "singleSelect",
          name: "Status",
          values: [
            {
              _id: "61ad79abfa4c7b40b81fa228",
              name: "📋 TODO",
              color: "red",
              value: "📋 TODO",
            },
            {
              _id: "61ad79abfa4c7b40b81fa229",
              name: "🚧 In Progress",
              color: "yellow",
              value: "🚧 In Progress",
            },
            {
              _id: "61ad79abfa4c7b40b81fa22a",
              name: "✔️ Done",
              color: "green",
              value: "✔️ Done",
            },
            {
              _id: "61ad79bafa4c7b40b81fa22f",
              color: "red",
              name: "asdfsadfdf",
              value: "asdfsadfdf",
            },
            {
              _id: "61ad79bdfa4c7b40b81fa230",
              color: "purple",
              name: "asdfsaf",
              value: "asdfsaf",
            },
          ],
          index: 0,
        },
      ],
      __v: 3,
      activeView: "61ad79a9fa4c7b40b81fa226",
      indexUpdatedOn: "2021-12-06T02:46:59.801Z",
      collections: [
        {
          _id: "61abbced5577261668b49c5a",
          name: "recent",
          tabs: [
            {
              pinned: false,
              _id: "61abbced5577261668b49c5b",
              active: false,
              favIconUrl:
                "data:image/png;base64,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",
              id: 82,
              index: 1,
              title: "(1) Daily Docket",
              url: "https://www.notion.so/matthewbf/Daily-Docket-088de001865645f88474eb82d73d75dc",
              windowId: 1,
              indexPosition: 99999,
              savedOn: "2021-12-04T19:09:33.948Z",
            },
            {
              pinned: false,
              _id: "61abbd045577261668b49c5c",
              id: 7,
              title: "Single lil tab :)",
              url: "www.docs.com/",
              favIconUrl: "https://ssl.gstatic.com/docs/doclist/images/mediatype/icon_1_document_x16.png",
              indexPosition: 100000,
              savedOn: "2021-12-04T19:09:56.999Z",
            },
          ],
          properties: [
            {
              values: ["61ad79abfa4c7b40b81fa228"],
              _id: "61ad79c5fa4c7b40b81fa231",
              propertyId: "61ad79abfa4c7b40b81fa227",
            },
          ],
          workspace: "61abb43c5577261668b49c58",
          userId: "619a9ae92f709e693cdc9d82",
          urlId: "teQlHmIxM",
          indexPosition: 0,
          createdOn: "2021-12-04T19:09:33.950Z",
          lastEdited: "2021-12-16T22:41:37.873Z",
          __v: 3,
          indexUpdatedOn: "2021-12-06T02:47:02.202Z",
        },
        {
          _id: "61ad50e5fa4c7b40b81fa178",
          name: "Copy of recent",
          urlId: "tetSHV1k2",
          userId: "619a9ae92f709e693cdc9d82",
          workspace: "61abb43c5577261668b49c58",
          tabs: [
            {
              pinned: false,
              _id: "61abbd045577261668b49c5c",
              id: 7,
              title: "Single lil tab :)",
              url: "www.docs.com/",
              favIconUrl: "https://ssl.gstatic.com/docs/doclist/images/mediatype/icon_1_document_x16.png",
              indexPosition: 100000,
              savedOn: "2021-12-04T19:09:56.999Z",
            },
          ],
          indexPosition: 999999,
          properties: [],
          createdOn: "2021-12-05T23:53:09.226Z",
          lastEdited: "2021-12-05T23:53:09.226Z",
          __v: 0,
        },
        {
          _id: "61ad50ebfa4c7b40b81fa17b",
          name: "sdfadsfdsfsaf",
          tabs: [
            {
              pinned: false,
              _id: "61ad50ebfa4c7b40b81fa17c",
              active: false,
              favIconUrl: "",
              id: 550,
              index: 1,
              title: "Extensions",
              url: "chrome://extensions/",
              windowId: 236,
              indexPosition: 99999,
              savedOn: "2021-12-05T23:53:15.889Z",
            },
            {
              pinned: false,
              _id: "61ad50ebfa4c7b40b81fa17d",
              active: false,
              favIconUrl:
                "data:image/png;base64,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",
              id: 248,
              index: 2,
              title: "/New TODO",
              url: "https://www.notion.so/matthewbf/New-TODO-6230223ec8dd4ca7aad23c69c6e41a26",
              windowId: 236,
              indexPosition: 100000,
              savedOn: "2021-12-05T23:53:15.889Z",
            },
            {
              pinned: false,
              _id: "61ad50ebfa4c7b40b81fa17e",
              active: true,
              favIconUrl: "http://localhost:3001/favicon.ico",
              id: 546,
              index: 3,
              title: "Partizion Dashboard",
              url: "http://localhost:3001/61abb43c5577261668b49c58",
              windowId: 236,
              indexPosition: 100001,
              savedOn: "2021-12-05T23:53:15.890Z",
            },
            {
              pinned: false,
              _id: "61ad50ebfa4c7b40b81fa17f",
              active: false,
              favIconUrl: "http://localhost:3001/favicon.ico",
              id: 530,
              index: 4,
              title: "New Collection | Partizion",
              url: "http://localhost:3001/new",
              windowId: 236,
              indexPosition: 100002,
              savedOn: "2021-12-05T23:53:15.890Z",
            },
            {
              pinned: false,
              _id: "61ad50ebfa4c7b40b81fa180",
              active: false,
              favIconUrl: "https://mui.com/static/favicon.ico",
              id: 639,
              index: 5,
              title: "Material icons - MUI",
              url: "https://mui.com/components/material-icons/",
              windowId: 236,
              indexPosition: 100003,
              savedOn: "2021-12-05T23:53:15.890Z",
            },
            {
              pinned: false,
              _id: "61ad50ebfa4c7b40b81fa181",
              active: false,
              favIconUrl: "https://ssl.gstatic.com/docs/documents/images/kix-favicon7.ico",
              id: 560,
              index: 2,
              title: "$1,250,000 Team Bonus plan - Google Docs",
              url: "https://docs.google.com/document/d/1rUpg1M9PPkeUOBHGQ7uL52uvk5EdxMRAbeWPBXFXtU8/edit",
              windowId: 554,
              indexPosition: 100004,
              savedOn: "2021-12-05T23:53:15.890Z",
            },
            {
              pinned: false,
              _id: "61ad50ebfa4c7b40b81fa182",
              active: false,
              favIconUrl:
                "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAzZJREFUWEftl21IU2EUx//Xu003m9t8L6dOl0Wahh8qSwOzjIJIKDIRQTKSyiL6UqBSoBn4rcgwC/SDflArykgK7Q16oTcTNDRfc1lTm+9zWdPtxr3q2p136pJpYc+XC/ee55zfPec855yHAADvCy0eegOVQQC7KUBJv7PXIoA2CrgnIImc7vQgDTFp/AWAIHsZtaK3RUASkYRrdvNFACcX2PiUuUuEW3Zzq73dbu3n6HDQHqBs+Xs/KR9igQPnlhG9EarBMVvUwSaAtAgZsra7z2jg3MNe5L0amDOETQD5cd6IDxWj4ZseXdpxlhHPZSRCvRxR0TiClFtd9gVIKFWjulXHMhKlEKIiSb5EAAZGDdAb2LkrIAnIhKR9PRC70hnF8ctBEgTjfoeJB4yTLONGCscqenC7QWufHLDUqjqtZGDkua1zNmgpaNMpWHoAMYEiyCV8q+7N3enBfDvzQGNVpls7jiqLI2subDUEHs4kPp4K/OPYmm8Mz+vAZysl2iqAQsZHTZoCGp0B5fXDnCCpG6RMEua/5i69cWvEkEt4iCpQoVGj59QxK8DzjlHElXzh3DzbKbiZ6IOtgaL/ALZ5QOpEIiFMDG8xDyc2yZj+XlQzhCaNnslmuvodCHOBu4hEerQb6KKY86QPwz+NKK4dYqriNqUIwZ6OSA6XIMCVj8J3Q2gf0KOsTov+UQMrnNNyoDJZjghfIWfM113+hH0hYpyN4Z4JMqs1qGzSofa4gnM/Vz5NA3h5xB+r3QXIedpnUpIQ5gKlKx87ijqxf60Yh9dLcb9Zh/fqH4xMpL8Q0QEiXH87iBsftKg66Iu2/jGU1v0+PRnRbmjq1WPzVdXMHpgCcDvfYhIsiV+BXaucWQBpd3tMBmjAK3u8WAA0YFK52qSjLzPoHwF4luqPYE8B6NY6tXiTfTe2sBN7Q8Q4ulHKJJuRmpBxIAgmOQveDDJF69EhP9BfDBY66FFuy7VZQkAnGT140krN19fhMSYEvhI+7iT5wInHnoy/jxmRWKZm3Fyd4gu5C7uHGCgKWY97UV7PnhXm1Y7n3SgIUH/FxWRxr2aLfjml47hg13M65hTaza/nvwCegssyiLThjAAAAABJRU5ErkJggg==",
              id: 561,
              index: 3,
              title: "Partizion: Growth Ideas - Airtable",
              url: "https://airtable.com/app1xlaKM2ul6Oyyf/tblapIt6RxKkmSRSH/viwBCoBoG1LBtgl6p?blocks=hide",
              windowId: 554,
              indexPosition: 100005,
              savedOn: "2021-12-05T23:53:15.891Z",
            },
            {
              pinned: false,
              _id: "61ad50ebfa4c7b40b81fa183",
              active: false,
              favIconUrl: "https://ssl.gstatic.com/docs/spreadsheets/favicon3.ico",
              id: 562,
              index: 4,
              title: "Partizion Growth Plan - Google Sheets",
              url: "https://docs.google.com/spreadsheets/d/1eSR0qilr9jw3xb3y75_KRKbzKs9NMtEHI6w0rj6prx4/edit?pli=1#gid=0",
              windowId: 554,
              indexPosition: 100006,
              savedOn: "2021-12-05T23:53:15.891Z",
            },
            {
              pinned: false,
              _id: "61ad50ebfa4c7b40b81fa184",
              active: false,
              favIconUrl: "https://stonks.com/favicon.ico",
              id: 567,
              index: 5,
              title: "Stonks — YC demo day for everyone",
              url: "https://stonks.com/dashboard/events/events",
              windowId: 554,
              indexPosition: 100007,
              savedOn: "2021-12-05T23:53:15.891Z",
            },
            {
              pinned: false,
              _id: "61ad50ebfa4c7b40b81fa185",
              active: false,
              favIconUrl: "https://stonks.com/favicon.ico",
              id: 568,
              index: 6,
              title: "Stonks Events | Stonks",
              url: "https://stonks.com/events",
              windowId: 554,
              indexPosition: 100008,
              savedOn: "2021-12-05T23:53:15.892Z",
            },
            {
              pinned: false,
              _id: "61ad50ebfa4c7b40b81fa186",
              active: false,
              favIconUrl: "https://staging.stonks.com/favicon.ico",
              id: 569,
              index: 7,
              title: "Stonks — YC demo day for everyone",
              url: "https://staging.stonks.com/",
              windowId: 554,
              indexPosition: 100009,
              savedOn: "2021-12-05T23:53:15.893Z",
            },
            {
              pinned: false,
              _id: "61ad50ebfa4c7b40b81fa187",
              active: false,
              favIconUrl: "https://dev.stonks.com/favicon.ico",
              id: 570,
              index: 8,
              title: "Stonks — YC demo day for everyone",
              url: "https://dev.stonks.com/",
              windowId: 554,
              indexPosition: 100010,
              savedOn: "2021-12-05T23:53:15.894Z",
            },
            {
              pinned: false,
              _id: "61ad50ebfa4c7b40b81fa188",
              active: false,
              favIconUrl: "https://www.google.com/favicon.ico",
              id: 571,
              index: 9,
              title: "Sign in - Google Accounts",
              url: "https://accounts.google.com/o/oauth2/v2/auth/oauthchooseaccount?access_type=online&login_hint=matthew%40stonks.com&scope=openid%20email%20profile&response_type=code&redirect_uri=https%3A%2F%2Fapp.logdna.com%2Fauth%2Fgooglesignin&state=e553a9e6959b819436fc6c9f4e8566cfedaad7ab1854d14e1cb1001cfc2f3042901cac01a9ae2cbebf47a8f194e40a50d48df845193c4ab5ca&prompt=select_account&client_id=235929664937-8fhm3jfrgn11hrq50a09r1587gsrbn7p.apps.googleusercontent.com&hd=stonks.com&as=S-184281579%3A1638739026132205&flowName=GeneralOAuthFlow",
              windowId: 554,
              indexPosition: 100011,
              savedOn: "2021-12-05T23:53:15.895Z",
            },
            {
              pinned: false,
              _id: "61ad50ebfa4c7b40b81fa189",
              active: false,
              favIconUrl: "https://ssl.gstatic.com/docs/spreadsheets/favicon3.ico",
              id: 572,
              index: 10,
              title: "Startup Signups - Google Sheets",
              url: "https://docs.google.com/spreadsheets/d/1Kfai0lnT96D7B7vzi_2auhZLsL5zqRrg_PY-Wf92Wn8/edit#gid=328970603",
              windowId: 554,
              indexPosition: 100012,
              savedOn: "2021-12-05T23:53:15.895Z",
            },
            {
              pinned: false,
              _id: "61ad50ebfa4c7b40b81fa18a",
              active: false,
              favIconUrl: "http://principal-api.stonks.com/favicon.ico",
              id: 573,
              index: 11,
              title: "Stonks API",
              url: "http://principal-api.stonks.com/",
              windowId: 554,
              indexPosition: 100013,
              savedOn: "2021-12-05T23:53:15.895Z",
            },
            {
              pinned: false,
              _id: "61ad50ebfa4c7b40b81fa18b",
              active: false,
              favIconUrl:
                "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAztJREFUWEftV21IU2EUfu6cd875sQ+XIla6uTQtLbQMtQ+M0kSlEIKKCgWpoOhH+CuKCPqTfwqCiKAwsA8orDTDviBD11AhofJzpmnT0G2mzrl5d2+8l5Sp7aYL9c/Or3vf855znvd5D+c9hwKAoJpYNe1gz3NAHgAtWVtCMVJAtVMiujKe2zVE8cEn2XqOgm4Jg85zTXHodAaIMihlpeYaB5xdzuDTsSjgOqWo1HQtA+2ezmckADhP2vCAVQgSy2CyD8Lusi+KJCUth4JWgGEZ9E70ebQVBNCV2wQlreCNOXBwsk702PpQbapFec9D9NtNvG5t4GqcjC3CnvBdCJeoESiWggLF66zOEWhrUrwDYMxthpwOxdfRdsj9Q6GWqECL6BlnLSNf+O9keeLMGgFpdlphcVqRGBK/eAASEY28yGzQIn+UJV+GmBIj4nn8TIAwiRKntMUo0Rzjr4fIOGPD7e57uGm8g2GHZWbvYEEbGI5BactFTLEMXg6+gY2ZmMXGvCuoyryPjLA0txNNzQIwrRBRIpjyCQMUIqsSwHLsPJoJAHKQaXk/1IAD9UeFARh2v4IuWItb3eUoij7EB3BnwN26P/8z/xtVteGvd0wAkOy52/MAJzTH0TlmRNrbvQsDoHyqBckBmVj2XwBsjI1PQst+ow+AjwEfAz4GvGOAPEZNlk8YmPyJH3YTagffoW5Iz1cz90pISnNORBY2yZOwLliDKGkkNiuSMOL85X0has3Rg/QEc4U8LK1jHdgYuh4ujkXbaAcSQuJAQMwV8jLqalK9q4TEmdRPChWtQIxsDbaqUpCu2oI0VSoC/aSzYk247NAPN0JvboTB0oxvtl6YHVY4WAe/z6tS7LGLAFAccwRXky7xW861XOAbFCFZNICy9huCDj+am6ANioaLc6HX1o80leeuhzgqjTu9sCR8llmB7WHbBIMTJcmD7LpCvvWq3fkEYsrvnzYGczP2fTgo/ByTZrIwqkDQ4Q51OrIjsmY5ejHwGg3DBo8gpjgGj75XYowZFwbwz2P82XBGV4Ki6MMgyVfR+5hvx7wRwa7YG4eLtOFWfjBZ8dFsxYdTcmfLOJ6TMbDbfTz/Db6BOK4bvgYdAAAAAElFTkSuQmCC",
              id: 576,
              index: 12,
              title: "Reading List: Reading List - Airtable",
              url: "https://airtable.com/appa18HZnmBAosioj/tblIyg6q9C38sbMxz/viwK9YYbVExbY0LT7?blocks=hide",
              windowId: 554,
              indexPosition: 100014,
              savedOn: "2021-12-05T23:53:15.895Z",
            },
          ],
          properties: [],
          workspace: "61abb43c5577261668b49c58",
          userId: "619a9ae92f709e693cdc9d82",
          urlId: "UMlhRmkLR",
          indexPosition: 999999,
          createdOn: "2021-12-05T23:53:15.895Z",
          lastEdited: "2021-12-05T23:53:15.895Z",
          __v: 0,
        },
        {
          _id: "61ad6814fa4c7b40b81fa1a9",
          name: "Tabs from Dec 5, 2021 6:32 PM",
          tabs: [
            {
              pinned: false,
              _id: "61ad6814fa4c7b40b81fa1aa",
              active: false,
              favIconUrl: "",
              id: 550,
              index: 1,
              title: "Extensions",
              url: "chrome://extensions/",
              windowId: 236,
              indexPosition: 99999,
              savedOn: "2021-12-06T01:32:04.982Z",
            },
            {
              pinned: false,
              _id: "61ad6814fa4c7b40b81fa1ab",
              active: false,
              favIconUrl:
                "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAABfZJREFUWEe1lnuIVFUcx3/nce+dO3dmZ3Y1V5IIc11f6bamm6QbSdZumUUvQXqZlWAP6PGPEOSKfygEUWCCoG31h0QFIavm/qEgu7qaSduK7sqibkgolq3zuO9zz4lz7owWpLvdcHaGHZiZ8/v8vr/v73d+CBI8/vxmSy4TBM9oQeksCHQJmLBAsCnAQwY+H0Hvbhsc77FovF/8+/fOd3ak7IuXXjQh2miYpo4REpgQRhEEhm4UdBGc0jV9E1qz+fRY5ycCqB7626fvDKBMbu7F4TOHGBJrdUIEzdblcrnalvq62h5j5XsnbxmAEICczg9+1iff0VQ+N/Rd7VufPDdWsH/7PJEC5a+3NIkrl9ehbP4lbOVMURodxc7oxz6Yn+Xf2DL6X0ASAbifb9jO/fJalK8HMNIA9ihA4TKAEEvSb289fMsBip0bNkdOaT3kbgPQUyDKo4CKfwhRO+meupc7Bm4ZwOWR/maNmvNEubCaB96DQDUVS/AIgDFOc/mvkFWzLwrtoxOmzL0wHpBxleD3od4sNms+0gzrBZJKW4jqgDCWkQEEACCkXiJiACwA5rsjQbnUMbGh+cuxIMYEEELgKyMnd9JUejUm9Pp5CIH8qz6EkCQCBBfAOQPOQhb65acnT2/puhnEmAAXzxx/lOqpfUQ3gBCizkIIAyIYkMxchpXBBQCPIlUOHjGIIg5R6PbjoNQ6ac7S8o0gxgS4cPrILt1Ir9KMFGBM4sAYA2cyUFQpAQAmRAHJ7KOQQcRCYLIcof/EnXe33lCFmwIMDfVm00wc01OZWQqAEMAYQ+CHwPwgDh5LomxAdQqYYnUlsDCAMPSBhV7H1KalGxMpMPLLoakI4b6UadVrhgGYUgj9EAJPBhcVB1RzkEYUQA0K0p8sCCEMPAg8d+e0BcteSwbw04H5SNd6DdMypQIyYa/sKvNXjC/Trygh4obAAFQjIASH0HfB993uhnsfbk8EMHziYBuldL9pWkANA0KZlRsoE8YE6nm9E7iEEEAoAkIwBIELvuedmL5g2YJEAGePH1iFNbrLtCwgVAPfCSAKI0BY1rwavYIgG0F1A49V0InygO86g9MXPjI7EcDw8e5XqWbsSFtZaXPwHR9ExFXwGEAGr2ogFICUvmpIFgXgOeWzjQvbGpIB/Ni9jmr6tnQ2p+rr254yn0xRzYLKHIiHQayABJBm1AwKUcTAdUrnGxe23ZUI4MzR/W9qhrHVkgBCArix4aolULPwn9OQ80gpoBkacMHAKRdHGlvapyYE6F6rGfp2CSCl9mw3LoHss0rvxyWQnRBnL1VQACldDSWnXDzX2NI2LRHA4LEfVumasSuTzQEiFLyyDVyaUNVfTsRK9vKf8l8MgAkGzdTVNLSLhaEZi9pnJQI4fWz/cp1qezLZvGpDt2wDc/24/ip4bMZ4IMqLiKt3RKegGzoEgQd2qdg/c1F7cyKAU0e6WnQt1ZPJ1eqGaULgB+AV7VjmyqVUnQfKJPJFMOgpeXFh8DwHnGLh4Mz7H3soIcDuBo2afdlc7UTdTKu6u6UyMDWK42zjaRSbUaqCdQqGaajLyvccKBWvfjFn8eOvJAIY6NlTa2i0L5uvm2GYaUCUKpmdYkndeKhyGSlPYKwuIsMyAXEBjIXguTY4VwubZj+w4sNEAEIINNS3r6smP2F5ysqoIIRQ4EKA7zjAGbumAqFUSS+poiCAiEVyBoBTKq2Z07qiMxGA/NHgkb2brWx+fTqTrSwhRN2KUu54AZGTD6trWs6AiMl9IFTvnVLBs53iknmtT51IDHDqcNezaavmWytTo/pfrmXVbQjheEOS5pMB5TYkAaQyEY9UC/LAbZm55MlSYoCh3t23EyM9kM3XTVAbkTQckRnL4JUBcG0XjLekWIkQiqNXdsxevOL1GwWvWPhmH8efnTz0/fuZXN3GVNqypNTS9TFAVYC4BTnnKrgyoF0atu3CyualK/v/N4A8oG/vV/cJQZowxfWE6hYmiCCOkEACg0CICyGfAUeiiDm6QEO/Z/7y538dK72/ABTA1D8jrLJhAAAAAElFTkSuQmCC",
              id: 248,
              index: 2,
              title: "/New TODO",
              url: "https://www.notion.so/matthewbf/New-TODO-6230223ec8dd4ca7aad23c69c6e41a26",
              windowId: 236,
              indexPosition: 100000,
              savedOn: "2021-12-06T01:32:04.983Z",
            },
            {
              pinned: false,
              _id: "61ad6814fa4c7b40b81fa1ac",
              active: true,
              favIconUrl: "http://localhost:3001/favicon.ico",
              id: 530,
              index: 3,
              title: "New Collection | Partizion",
              url: "http://localhost:3001/new",
              windowId: 236,
              indexPosition: 100001,
              savedOn: "2021-12-06T01:32:04.983Z",
            },
            {
              pinned: false,
              _id: "61ad6814fa4c7b40b81fa1ad",
              active: false,
              favIconUrl: "https://mui.com/static/favicon.ico",
              id: 639,
              index: 4,
              title: "Button API - MUI",
              url: "https://mui.com/api/button/",
              windowId: 236,
              indexPosition: 100002,
              savedOn: "2021-12-06T01:32:04.983Z",
            },
            {
              pinned: false,
              _id: "61ad6814fa4c7b40b81fa1ae",
              active: false,
              favIconUrl: "https://developer.mozilla.org/favicon-48x48.97046865.png",
              id: 712,
              index: 5,
              title: "GlobalEventHandlers.onclick - Web APIs | MDN",
              url: "https://developer.mozilla.org/en-US/docs/Web/API/GlobalEventHandlers/onclick",
              windowId: 236,
              indexPosition: 100003,
              savedOn: "2021-12-06T01:32:04.983Z",
            },
          ],
          workspace: "61abb43c5577261668b49c58",
          userId: "619a9ae92f709e693cdc9d82",
          urlId: "HnyBnsBeq",
          indexPosition: 999999,
          createdOn: "2021-12-06T01:32:04.984Z",
          lastEdited: "2021-12-06T01:32:04.984Z",
          properties: [],
          __v: 0,
        },
        {
          _id: "61ad79b5fa4c7b40b81fa22c",
          name: "asdfadsf",
          tabs: [
            {
              pinned: false,
              savedOn: "2021-12-06T02:47:17.881Z",
              _id: "61ad79b5fa4c7b40b81fa22d",
              active: false,
              favIconUrl: "https://mui.com/static/favicon.ico",
              id: 807,
              index: 2,
              title: "Tab API - MUI",
              url: "https://mui.com/api/tab/",
              windowId: 236,
              indexPosition: 0,
            },
            {
              pinned: false,
              _id: "61abbced5577261668b49c5b",
              active: false,
              favIconUrl:
                "data:image/png;base64,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",
              id: 82,
              index: 1,
              title: "(1) Daily Docket",
              url: "https://www.notion.so/matthewbf/Daily-Docket-088de001865645f88474eb82d73d75dc",
              windowId: 1,
              indexPosition: 1,
              savedOn: "2021-12-04T19:09:33.948Z",
              indexUpdatedOn: "2021-12-06T02:47:53.323Z",
            },
          ],
          properties: [
            {
              values: ["61ad79abfa4c7b40b81fa228"],
              _id: "61ad79b5fa4c7b40b81fa22e",
              propertyId: "61ad79abfa4c7b40b81fa227",
            },
          ],
          workspace: "61abb43c5577261668b49c58",
          userId: "619a9ae92f709e693cdc9d82",
          urlId: "QxMDcPaqx",
          indexPosition: 999999,
          createdOn: "2021-12-06T02:47:17.883Z",
          lastEdited: "2021-12-23T21:29:46.153Z",
          __v: 5,
        },
        {
          _id: "61ad79cbfa4c7b40b81fa232",
          name: "sdfadsffafdsaf",
          tabs: [
            {
              pinned: false,
              _id: "61ad79cbfa4c7b40b81fa233",
              active: false,
              favIconUrl: "https://mui.com/static/favicon.ico",
              id: 807,
              index: 2,
              title: "Tab API - MUI",
              url: "https://mui.com/api/tab/",
              windowId: 236,
              indexPosition: 99999,
              savedOn: "2021-12-06T02:47:39.977Z",
            },
          ],
          properties: [
            {
              values: ["61ad79abfa4c7b40b81fa22a"],
              _id: "61ad79cbfa4c7b40b81fa234",
              propertyId: "61ad79abfa4c7b40b81fa227",
            },
          ],
          workspace: "61abb43c5577261668b49c58",
          userId: "619a9ae92f709e693cdc9d82",
          urlId: "1FEHuUMbO",
          indexPosition: 999999,
          createdOn: "2021-12-06T02:47:39.978Z",
          lastEdited: "2021-12-06T02:47:44.505Z",
          __v: 1,
        },
        {
          _id: "61c4e9b814222604087247a9",
          name: "Copy of Copy of Copy of hello mate 989",
          urlId: "dzm6D30ZX",
          userId: "619a9ae92f709e693cdc9d82",
          workspace: "61abb43c5577261668b49c58",
          tabs: [
            {
              pinned: false,
              _id: "61c4dc321422260408724772",
              active: false,
              favIconUrl: "https://airtable.com/images/favicon/baymax/favicon-32x32.png",
              id: 320,
              index: 5,
              title: "Sign in - Airtable",
              url: "https://airtable.com/login?continue=%2Fappa18HZnmBAosioj%2FtblIyg6q9C38sbMxz%2FviwK9YYbVExbY0LT7%3Fblocks%3Dhide",
              windowId: 304,
              indexPosition: 99999,
              savedOn: "2021-12-23T20:29:38.975Z",
            },
            {
              pinned: false,
              _id: "61c4dc321422260408724773",
              active: false,
              favIconUrl: "https://stonks.com/favicon.ico",
              id: 360,
              index: 2,
              title: "Demo Days | Stonks",
              url: "https://stonks.com/dashboard/xoogler/events",
              windowId: 155,
              indexPosition: 100000,
              savedOn: "2021-12-23T20:29:38.976Z",
            },
          ],
          indexPosition: 999999,
          properties: [],
          createdOn: "2021-12-23T21:27:20.861Z",
          lastEdited: "2021-12-23T21:27:20.861Z",
          __v: 0,
        },
        {
          _id: "61c4dc321422260408724771",
          name: "hello mate 989",
          tabs: [
            {
              pinned: false,
              _id: "61c4dc321422260408724772",
              active: false,
              favIconUrl: "https://airtable.com/images/favicon/baymax/favicon-32x32.png",
              id: 320,
              index: 5,
              title: "Sign in - Airtable",
              url: "https://airtable.com/login?continue=%2Fappa18HZnmBAosioj%2FtblIyg6q9C38sbMxz%2FviwK9YYbVExbY0LT7%3Fblocks%3Dhide",
              windowId: 304,
              indexPosition: 99999,
              savedOn: "2021-12-23T20:29:38.975Z",
            },
            {
              pinned: false,
              _id: "61c4dc321422260408724773",
              active: false,
              favIconUrl: "https://stonks.com/favicon.ico",
              id: 360,
              index: 2,
              title: "Demo Days | Stonks",
              url: "https://stonks.com/dashboard/xoogler/events",
              windowId: 155,
              indexPosition: 100000,
              savedOn: "2021-12-23T20:29:38.976Z",
            },
          ],
          properties: [],
          workspace: "61abb43c5577261668b49c58",
          userId: "619a9ae92f709e693cdc9d82",
          urlId: "VQfTvYkDM",
          indexPosition: 9999999,
          createdOn: "2021-12-23T20:29:38.976Z",
          lastEdited: "2021-12-23T20:29:38.976Z",
          __v: 0,
        },
      ],
    },
    {
      _id: "61ad77cefa4c7b40b81fa213",
      icon: {
        emoticons: [],
        short_names: [],
      },
      name: "asdfasdf",
      userId: "619a9ae92f709e693cdc9d82",
      indexPosition: 1,
      createdOn: "2021-12-06T02:39:10.862Z",
      collectionProperties: [],
      __v: 0,
      activeView: "61ad78e3fa4c7b40b81fa220",
      indexUpdatedOn: "2021-12-06T02:46:59.802Z",
      collections: [
        {
          _id: "61ad77d2fa4c7b40b81fa214",
          name: "ONE",
          tabs: [
            {
              pinned: false,
              savedOn: "2021-12-06T02:39:14.024Z",
              _id: "61ad77d2fa4c7b40b81fa215",
              active: true,
              favIconUrl: "http://localhost:3001/favicon.ico",
              id: 803,
              index: 3,
              title: "Partizion Dashboard",
              url: "http://localhost:3001/61ad77cefa4c7b40b81fa213",
              windowId: 236,
              indexPosition: 1,
              indexUpdatedOn: "2021-12-06T02:44:02.971Z",
            },
            {
              pinned: false,
              _id: "61ad78d9fa4c7b40b81fa21f",
              active: false,
              favIconUrl: "https://mui.com/static/favicon.ico",
              id: 807,
              index: 2,
              title: "Tab API - MUI",
              url: "https://mui.com/api/tab/",
              windowId: 236,
              indexPosition: 0,
              savedOn: "2021-12-06T02:43:37.960Z",
              indexUpdatedOn: "2021-12-06T02:44:02.971Z",
            },
          ],
          properties: [],
          workspace: "61ad77cefa4c7b40b81fa213",
          userId: "619a9ae92f709e693cdc9d82",
          urlId: "2zcOt2rEq",
          indexPosition: 999999,
          createdOn: "2021-12-06T02:39:14.024Z",
          lastEdited: "2021-12-06T02:44:00.261Z",
          __v: 1,
        },
        {
          _id: "61ad78d9fa4c7b40b81fa21e",
          name: "asdfadsf",
          tabs: [],
          properties: [],
          workspace: "61ad77cefa4c7b40b81fa213",
          userId: "619a9ae92f709e693cdc9d82",
          urlId: "yaR0HcGm2",
          indexPosition: 999999,
          createdOn: "2021-12-06T02:43:37.961Z",
          lastEdited: "2021-12-06T02:43:37.961Z",
          __v: 0,
        },
        {
          _id: "61c65c92d65dfc241df638fa",
          name: "hello",
          tabs: [
            {
              pinned: false,
              _id: "61c65c92d65dfc241df638fb",
              active: false,
              favIconUrl: "https://dashboard.render.com/favicon.ico",
              id: 187,
              index: 1,
              title: "Render Dashboard",
              url: "https://dashboard.render.com/",
              windowId: 140,
              indexPosition: 99999,
              savedOn: "2021-12-24T23:49:38.417Z",
            },
          ],
          properties: [],
          workspace: "61ad77cefa4c7b40b81fa213",
          userId: "619a9ae92f709e693cdc9d82",
          urlId: "SYSqhSDSs",
          indexPosition: 999999,
          createdOn: "2021-12-24T23:49:38.418Z",
          lastEdited: "2021-12-24T23:49:38.418Z",
          __v: 0,
        },
        {
          _id: "61c4dcf61422260408724786",
          name: "Copy of hello mate 989",
          urlId: "vWGjbf6be",
          userId: "619a9ae92f709e693cdc9d82",
          workspace: "61ad77cefa4c7b40b81fa213",
          tabs: [
            {
              pinned: false,
              _id: "61c4dc321422260408724772",
              active: false,
              favIconUrl: "https://airtable.com/images/favicon/baymax/favicon-32x32.png",
              id: 320,
              index: 5,
              title: "Sign in - Airtable",
              url: "https://airtable.com/login?continue=%2Fappa18HZnmBAosioj%2FtblIyg6q9C38sbMxz%2FviwK9YYbVExbY0LT7%3Fblocks%3Dhide",
              windowId: 304,
              indexPosition: 99999,
              savedOn: "2021-12-23T20:29:38.975Z",
            },
            {
              pinned: false,
              _id: "61c4dc321422260408724773",
              active: false,
              favIconUrl: "https://stonks.com/favicon.ico",
              id: 360,
              index: 2,
              title: "Demo Days | Stonks",
              url: "https://stonks.com/dashboard/xoogler/events",
              windowId: 155,
              indexPosition: 100000,
              savedOn: "2021-12-23T20:29:38.976Z",
            },
          ],
          indexPosition: 9999999,
          properties: [],
          createdOn: "2021-12-23T20:32:54.745Z",
          lastEdited: "2021-12-23T20:32:54.745Z",
          __v: 0,
        },
        {
          _id: "61c4df461422260408724792",
          name: "Copy of Copy of hello mate 989",
          urlId: "3ZTHSWZzj",
          userId: "619a9ae92f709e693cdc9d82",
          workspace: "61ad77cefa4c7b40b81fa213",
          tabs: [
            {
              pinned: false,
              _id: "61c4dc321422260408724772",
              active: false,
              favIconUrl: "https://airtable.com/images/favicon/baymax/favicon-32x32.png",
              id: 320,
              index: 5,
              title: "Sign in - Airtable",
              url: "https://airtable.com/login?continue=%2Fappa18HZnmBAosioj%2FtblIyg6q9C38sbMxz%2FviwK9YYbVExbY0LT7%3Fblocks%3Dhide",
              windowId: 304,
              indexPosition: 99999,
              savedOn: "2021-12-23T20:29:38.975Z",
            },
            {
              pinned: false,
              _id: "61c4dc321422260408724773",
              active: false,
              favIconUrl: "https://stonks.com/favicon.ico",
              id: 360,
              index: 2,
              title: "Demo Days | Stonks",
              url: "https://stonks.com/dashboard/xoogler/events",
              windowId: 155,
              indexPosition: 100000,
              savedOn: "2021-12-23T20:29:38.976Z",
            },
          ],
          indexPosition: 9999999,
          properties: [],
          createdOn: "2021-12-23T20:42:46.316Z",
          lastEdited: "2021-12-23T20:42:46.316Z",
          __v: 0,
        },
      ],
    },
    {
      _id: "61abdead5577261668b49c5f",
      icon: {
        id: "new",
        name: "Squared New",
        short_names: ["new"],
        colons: ":new:",
        emoticons: [],
        unified: "1f195",
        skin: null,
        native: "🆕",
      },
      name: "SLASH NEW testing",
      userId: "619a9ae92f709e693cdc9d82",
      indexPosition: 2,
      createdOn: "2021-12-04T21:33:33.752Z",
      collectionProperties: [],
      __v: 0,
      activeView: "61ad7401fa4c7b40b81fa1f7",
      indexUpdatedOn: "2021-12-06T02:46:59.802Z",
      collections: [
        {
          _id: "61ad50c8fa4c7b40b81fa169",
          name: "FOUR",
          tabs: [
            {
              pinned: false,
              _id: "61ad50c8fa4c7b40b81fa16a",
              active: false,
              favIconUrl:
                "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAztJREFUWEftV21IU2EUfu6cd875sQ+XIla6uTQtLbQMtQ+M0kSlEIKKCgWpoOhH+CuKCPqTfwqCiKAwsA8orDTDviBD11AhofJzpmnT0G2mzrl5d2+8l5Sp7aYL9c/Or3vf855znvd5D+c9hwKAoJpYNe1gz3NAHgAtWVtCMVJAtVMiujKe2zVE8cEn2XqOgm4Jg85zTXHodAaIMihlpeYaB5xdzuDTsSjgOqWo1HQtA+2ezmckADhP2vCAVQgSy2CyD8Lusi+KJCUth4JWgGEZ9E70ebQVBNCV2wQlreCNOXBwsk702PpQbapFec9D9NtNvG5t4GqcjC3CnvBdCJeoESiWggLF66zOEWhrUrwDYMxthpwOxdfRdsj9Q6GWqECL6BlnLSNf+O9keeLMGgFpdlphcVqRGBK/eAASEY28yGzQIn+UJV+GmBIj4nn8TIAwiRKntMUo0Rzjr4fIOGPD7e57uGm8g2GHZWbvYEEbGI5BactFTLEMXg6+gY2ZmMXGvCuoyryPjLA0txNNzQIwrRBRIpjyCQMUIqsSwHLsPJoJAHKQaXk/1IAD9UeFARh2v4IuWItb3eUoij7EB3BnwN26P/8z/xtVteGvd0wAkOy52/MAJzTH0TlmRNrbvQsDoHyqBckBmVj2XwBsjI1PQst+ow+AjwEfAz4GvGOAPEZNlk8YmPyJH3YTagffoW5Iz1cz90pISnNORBY2yZOwLliDKGkkNiuSMOL85X0has3Rg/QEc4U8LK1jHdgYuh4ujkXbaAcSQuJAQMwV8jLqalK9q4TEmdRPChWtQIxsDbaqUpCu2oI0VSoC/aSzYk247NAPN0JvboTB0oxvtl6YHVY4WAe/z6tS7LGLAFAccwRXky7xW861XOAbFCFZNICy9huCDj+am6ANioaLc6HX1o80leeuhzgqjTu9sCR8llmB7WHbBIMTJcmD7LpCvvWq3fkEYsrvnzYGczP2fTgo/ByTZrIwqkDQ4Q51OrIjsmY5ejHwGg3DBo8gpjgGj75XYowZFwbwz2P82XBGV4Ki6MMgyVfR+5hvx7wRwa7YG4eLtOFWfjBZ8dFsxYdTcmfLOJ6TMbDbfTz/Db6BOK4bvgYdAAAAAElFTkSuQmCC",
              id: 576,
              index: 12,
              title: "Reading List: Reading List - Airtable",
              url: "https://airtable.com/appa18HZnmBAosioj/tblIyg6q9C38sbMxz/viwK9YYbVExbY0LT7?blocks=hide",
              windowId: 554,
              indexPosition: 99999,
              savedOn: "2021-12-05T23:52:40.541Z",
            },
          ],
          properties: [],
          workspace: "61abdead5577261668b49c5f",
          userId: "619a9ae92f709e693cdc9d82",
          urlId: "_SBMrNnvo",
          indexPosition: 0,
          createdOn: "2021-12-05T23:52:40.542Z",
          lastEdited: "2021-12-05T23:52:40.542Z",
          __v: 0,
          indexUpdatedOn: "2021-12-06T02:46:07.076Z",
        },
        {
          _id: "61ad50c4fa4c7b40b81fa166",
          name: "THREE",
          tabs: [
            {
              pinned: false,
              _id: "61ad50c4fa4c7b40b81fa167",
              active: false,
              favIconUrl: "https://ssl.gstatic.com/docs/spreadsheets/favicon3.ico",
              id: 572,
              index: 10,
              title: "Startup Signups - Google Sheets",
              url: "https://docs.google.com/spreadsheets/d/1Kfai0lnT96D7B7vzi_2auhZLsL5zqRrg_PY-Wf92Wn8/edit#gid=328970603",
              windowId: 554,
              indexPosition: 99999,
              savedOn: "2021-12-05T23:52:36.491Z",
            },
            {
              pinned: false,
              _id: "61ad50c4fa4c7b40b81fa168",
              active: false,
              favIconUrl: "https://www.google.com/favicon.ico",
              id: 571,
              index: 9,
              title: "Sign in - Google Accounts",
              url: "https://accounts.google.com/o/oauth2/v2/auth/oauthchooseaccount?access_type=online&login_hint=matthew%40stonks.com&scope=openid%20email%20profile&response_type=code&redirect_uri=https%3A%2F%2Fapp.logdna.com%2Fauth%2Fgooglesignin&state=e553a9e6959b819436fc6c9f4e8566cfedaad7ab1854d14e1cb1001cfc2f3042901cac01a9ae2cbebf47a8f194e40a50d48df845193c4ab5ca&prompt=select_account&client_id=235929664937-8fhm3jfrgn11hrq50a09r1587gsrbn7p.apps.googleusercontent.com&hd=stonks.com&as=S-184281579%3A1638739026132205&flowName=GeneralOAuthFlow",
              windowId: 554,
              indexPosition: 100000,
              savedOn: "2021-12-05T23:52:36.493Z",
            },
            {
              pinned: false,
              _id: "61ad6917fa4c7b40b81fa1af",
              active: false,
              favIconUrl: "https://ssl.gstatic.com/docs/documents/images/kix-favicon7.ico",
              id: 733,
              index: 4,
              title: "$1,250,000 Team Bonus plan - Google Docs",
              url: "https://docs.google.com/document/d/1rUpg1M9PPkeUOBHGQ7uL52uvk5EdxMRAbeWPBXFXtU8/edit",
              windowId: 236,
              indexPosition: 100001,
              savedOn: "2021-12-06T01:36:23.949Z",
            },
            {
              pinned: false,
              _id: "61ad6917fa4c7b40b81fa1b0",
              active: false,
              favIconUrl: "https://calendar.google.com/googlecalendar/images/favicons_2020q4/calendar_5.ico",
              id: 730,
              index: 3,
              title: "Stonks - Calendar - December 2021",
              url: "https://calendar.google.com/calendar/u/2/r?tab=mc&pli=1",
              windowId: 236,
              indexPosition: 100002,
              savedOn: "2021-12-06T01:36:23.950Z",
            },
          ],
          properties: [],
          workspace: "61abdead5577261668b49c5f",
          userId: "619a9ae92f709e693cdc9d82",
          urlId: "CkdsMUrmE",
          indexPosition: 1,
          createdOn: "2021-12-05T23:52:36.493Z",
          lastEdited: "2021-12-06T01:36:23.950Z",
          __v: 1,
          indexUpdatedOn: "2021-12-06T02:46:07.076Z",
        },
        {
          _id: "61ad50bafa4c7b40b81fa161",
          name: "ONE",
          tabs: [
            {
              pinned: false,
              savedOn: "2021-12-05T23:52:26.890Z",
              _id: "61ad50bafa4c7b40b81fa162",
              active: false,
              favIconUrl: "",
              id: 550,
              index: 1,
              title: "Extensions",
              url: "chrome://extensions/",
              windowId: 236,
              indexPosition: 0,
            },
            {
              pinned: false,
              savedOn: "2021-12-05T23:52:26.891Z",
              _id: "61ad50bafa4c7b40b81fa163",
              active: false,
              favIconUrl:
                "data:image/png;base64,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",
              id: 248,
              index: 2,
              title: "/New TODO",
              url: "https://www.notion.so/matthewbf/New-TODO-6230223ec8dd4ca7aad23c69c6e41a26",
              windowId: 236,
              indexPosition: 1,
            },
            {
              pinned: false,
              _id: "61ad63cafa4c7b40b81fa190",
              active: false,
              favIconUrl: "https://mui.com/static/favicon.ico",
              id: 639,
              index: 4,
              title: "Button API - MUI",
              url: "https://mui.com/api/button/",
              windowId: 236,
              indexPosition: 2,
              savedOn: "2021-12-06T01:13:46.722Z",
              indexUpdatedOn: "2021-12-06T02:46:51.717Z",
            },
          ],
          properties: [],
          workspace: "61abdead5577261668b49c5f",
          userId: "619a9ae92f709e693cdc9d82",
          urlId: "SnuURbv2O",
          indexPosition: 2,
          createdOn: "2021-12-05T23:52:26.892Z",
          lastEdited: "2021-12-06T02:46:51.718Z",
          __v: 1,
          indexUpdatedOn: "2021-12-06T02:46:07.076Z",
        },
        {
          _id: "61ad50befa4c7b40b81fa164",
          name: "Two",
          tabs: [
            {
              pinned: false,
              _id: "61ad50befa4c7b40b81fa165",
              active: false,
              favIconUrl: "https://mui.com/static/favicon.ico",
              id: 639,
              index: 5,
              title: "Material icons - MUI",
              url: "https://mui.com/components/material-icons/",
              windowId: 236,
              indexPosition: 99999,
              savedOn: "2021-12-05T23:52:30.188Z",
            },
          ],
          properties: [],
          workspace: "61abdead5577261668b49c5f",
          userId: "619a9ae92f709e693cdc9d82",
          urlId: "XOh_BAQFN",
          indexPosition: 3,
          createdOn: "2021-12-05T23:52:30.188Z",
          lastEdited: "2021-12-05T23:52:30.189Z",
          __v: 0,
          indexUpdatedOn: "2021-12-06T02:46:07.076Z",
        },
        {
          _id: "61ad50cdfa4c7b40b81fa16b",
          name: "FIVE",
          tabs: [
            {
              pinned: false,
              _id: "61ad50cdfa4c7b40b81fa16c",
              active: false,
              favIconUrl: "https://staging.stonks.com/favicon.ico",
              id: 569,
              index: 7,
              title: "Stonks — YC demo day for everyone",
              url: "https://staging.stonks.com/",
              windowId: 554,
              indexPosition: 99999,
              savedOn: "2021-12-05T23:52:45.482Z",
            },
          ],
          properties: [],
          workspace: "61abdead5577261668b49c5f",
          userId: "619a9ae92f709e693cdc9d82",
          urlId: "BhDJpT_p0",
          indexPosition: 4,
          createdOn: "2021-12-05T23:52:45.482Z",
          lastEdited: "2021-12-05T23:52:45.482Z",
          __v: 0,
          indexUpdatedOn: "2021-12-06T02:46:07.076Z",
        },
        {
          _id: "61ad50d0fa4c7b40b81fa16d",
          name: "EMPTY",
          tabs: [],
          properties: [],
          workspace: "61abdead5577261668b49c5f",
          userId: "619a9ae92f709e693cdc9d82",
          urlId: "cWchWvX2z",
          indexPosition: 5,
          createdOn: "2021-12-05T23:52:48.856Z",
          lastEdited: "2021-12-05T23:52:48.856Z",
          __v: 0,
          indexUpdatedOn: "2021-12-06T02:46:07.076Z",
        },
        {
          _id: "61ad50d8fa4c7b40b81fa16f",
          name: "Copy of THREE",
          urlId: "Ry2uZM7aR",
          userId: "619a9ae92f709e693cdc9d82",
          workspace: "61abdead5577261668b49c5f",
          tabs: [
            {
              pinned: false,
              _id: "61ad50c4fa4c7b40b81fa168",
              active: false,
              favIconUrl: "https://www.google.com/favicon.ico",
              id: 571,
              index: 9,
              title: "Sign in - Google Accounts",
              url: "https://accounts.google.com/o/oauth2/v2/auth/oauthchooseaccount?access_type=online&login_hint=matthew%40stonks.com&scope=openid%20email%20profile&response_type=code&redirect_uri=https%3A%2F%2Fapp.logdna.com%2Fauth%2Fgooglesignin&state=e553a9e6959b819436fc6c9f4e8566cfedaad7ab1854d14e1cb1001cfc2f3042901cac01a9ae2cbebf47a8f194e40a50d48df845193c4ab5ca&prompt=select_account&client_id=235929664937-8fhm3jfrgn11hrq50a09r1587gsrbn7p.apps.googleusercontent.com&hd=stonks.com&as=S-184281579%3A1638739026132205&flowName=GeneralOAuthFlow",
              windowId: 554,
              indexPosition: 0,
              savedOn: "2021-12-05T23:52:36.493Z",
              indexUpdatedOn: "2021-12-06T02:46:41.213Z",
            },
          ],
          indexPosition: 6,
          properties: [],
          createdOn: "2021-12-05T23:52:56.203Z",
          lastEdited: "2021-12-06T02:46:42.995Z",
          __v: 1,
          indexUpdatedOn: "2021-12-06T02:46:07.076Z",
        },
        {
          _id: "61ad50dafa4c7b40b81fa172",
          name: "Copy of ONE",
          urlId: "_AhqhHJAz",
          userId: "619a9ae92f709e693cdc9d82",
          workspace: "61abdead5577261668b49c5f",
          tabs: [
            {
              pinned: false,
              _id: "61ad50bafa4c7b40b81fa162",
              active: false,
              favIconUrl: "",
              id: 550,
              index: 1,
              title: "Extensions",
              url: "chrome://extensions/",
              windowId: 236,
              indexPosition: 99999,
              savedOn: "2021-12-05T23:52:26.890Z",
            },
            {
              pinned: false,
              _id: "61ad50bafa4c7b40b81fa163",
              active: false,
              favIconUrl:
                "data:image/png;base64,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",
              id: 248,
              index: 2,
              title: "/New TODO",
              url: "https://www.notion.so/matthewbf/New-TODO-6230223ec8dd4ca7aad23c69c6e41a26",
              windowId: 236,
              indexPosition: 100000,
              savedOn: "2021-12-05T23:52:26.891Z",
            },
          ],
          indexPosition: 7,
          properties: [],
          createdOn: "2021-12-05T23:52:58.375Z",
          lastEdited: "2021-12-05T23:52:58.375Z",
          __v: 0,
          indexUpdatedOn: "2021-12-06T02:46:07.076Z",
        },
        {
          _id: "61ad50d5fa4c7b40b81fa16e",
          name: "asdfdsafa",
          urlId: "0oMdCx81u",
          userId: "619a9ae92f709e693cdc9d82",
          workspace: "61abdead5577261668b49c5f",
          tabs: [
            {
              pinned: false,
              _id: "61ad63e9fa4c7b40b81fa193",
              active: false,
              favIconUrl: "",
              id: 550,
              index: 1,
              title: "Extensions",
              url: "chrome://extensions/",
              windowId: 236,
              indexPosition: 0,
              savedOn: "2021-12-06T01:14:17.526Z",
              indexUpdatedOn: "2021-12-06T02:46:05.111Z",
            },
          ],
          indexPosition: 8,
          properties: [],
          createdOn: "2021-12-05T23:52:53.312Z",
          lastEdited: "2021-12-06T02:46:05.112Z",
          __v: 1,
          indexUpdatedOn: "2021-12-06T02:46:07.076Z",
        },
        {
          _id: "61ad50ddfa4c7b40b81fa175",
          name: "Copy of Copy of ONE",
          urlId: "9TECc3b52",
          userId: "619a9ae92f709e693cdc9d82",
          workspace: "61abdead5577261668b49c5f",
          tabs: [
            {
              pinned: false,
              _id: "61ad50bafa4c7b40b81fa162",
              active: false,
              favIconUrl: "",
              id: 550,
              index: 1,
              title: "Extensions",
              url: "chrome://extensions/",
              windowId: 236,
              indexPosition: 99999,
              savedOn: "2021-12-05T23:52:26.890Z",
            },
            {
              pinned: false,
              _id: "61ad50bafa4c7b40b81fa163",
              active: false,
              favIconUrl:
                "data:image/png;base64,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",
              id: 248,
              index: 2,
              title: "/New TODO",
              url: "https://www.notion.so/matthewbf/New-TODO-6230223ec8dd4ca7aad23c69c6e41a26",
              windowId: 236,
              indexPosition: 100000,
              savedOn: "2021-12-05T23:52:26.891Z",
            },
          ],
          indexPosition: 9,
          properties: [],
          createdOn: "2021-12-05T23:53:01.745Z",
          lastEdited: "2021-12-05T23:53:01.745Z",
          __v: 0,
          indexUpdatedOn: "2021-12-06T02:46:07.076Z",
        },
        {
          _id: "61ad63cafa4c7b40b81fa18c",
          name: "FIRST SESSION saved from /new",
          tabs: [
            {
              pinned: false,
              _id: "61ad63cafa4c7b40b81fa18d",
              active: false,
              favIconUrl: "",
              id: 550,
              index: 1,
              title: "Extensions",
              url: "chrome://extensions/",
              windowId: 236,
              indexPosition: 99999,
              savedOn: "2021-12-06T01:13:46.721Z",
            },
            {
              pinned: false,
              _id: "61ad63cafa4c7b40b81fa18e",
              active: false,
              favIconUrl:
                "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAABfZJREFUWEe1lnuIVFUcx3/nce+dO3dmZ3Y1V5IIc11f6bamm6QbSdZumUUvQXqZlWAP6PGPEOSKfygEUWCCoG31h0QFIavm/qEgu7qaSduK7sqibkgolq3zuO9zz4lz7owWpLvdcHaGHZiZ8/v8vr/v73d+CBI8/vxmSy4TBM9oQeksCHQJmLBAsCnAQwY+H0Hvbhsc77FovF/8+/fOd3ak7IuXXjQh2miYpo4REpgQRhEEhm4UdBGc0jV9E1qz+fRY5ycCqB7626fvDKBMbu7F4TOHGBJrdUIEzdblcrnalvq62h5j5XsnbxmAEICczg9+1iff0VQ+N/Rd7VufPDdWsH/7PJEC5a+3NIkrl9ehbP4lbOVMURodxc7oxz6Yn+Xf2DL6X0ASAbifb9jO/fJalK8HMNIA9ihA4TKAEEvSb289fMsBip0bNkdOaT3kbgPQUyDKo4CKfwhRO+meupc7Bm4ZwOWR/maNmvNEubCaB96DQDUVS/AIgDFOc/mvkFWzLwrtoxOmzL0wHpBxleD3od4sNms+0gzrBZJKW4jqgDCWkQEEACCkXiJiACwA5rsjQbnUMbGh+cuxIMYEEELgKyMnd9JUejUm9Pp5CIH8qz6EkCQCBBfAOQPOQhb65acnT2/puhnEmAAXzxx/lOqpfUQ3gBCizkIIAyIYkMxchpXBBQCPIlUOHjGIIg5R6PbjoNQ6ac7S8o0gxgS4cPrILt1Ir9KMFGBM4sAYA2cyUFQpAQAmRAHJ7KOQQcRCYLIcof/EnXe33lCFmwIMDfVm00wc01OZWQqAEMAYQ+CHwPwgDh5LomxAdQqYYnUlsDCAMPSBhV7H1KalGxMpMPLLoakI4b6UadVrhgGYUgj9EAJPBhcVB1RzkEYUQA0K0p8sCCEMPAg8d+e0BcteSwbw04H5SNd6DdMypQIyYa/sKvNXjC/Trygh4obAAFQjIASH0HfB993uhnsfbk8EMHziYBuldL9pWkANA0KZlRsoE8YE6nm9E7iEEEAoAkIwBIELvuedmL5g2YJEAGePH1iFNbrLtCwgVAPfCSAKI0BY1rwavYIgG0F1A49V0InygO86g9MXPjI7EcDw8e5XqWbsSFtZaXPwHR9ExFXwGEAGr2ogFICUvmpIFgXgOeWzjQvbGpIB/Ni9jmr6tnQ2p+rr254yn0xRzYLKHIiHQayABJBm1AwKUcTAdUrnGxe23ZUI4MzR/W9qhrHVkgBCArix4aolULPwn9OQ80gpoBkacMHAKRdHGlvapyYE6F6rGfp2CSCl9mw3LoHss0rvxyWQnRBnL1VQACldDSWnXDzX2NI2LRHA4LEfVumasSuTzQEiFLyyDVyaUNVfTsRK9vKf8l8MgAkGzdTVNLSLhaEZi9pnJQI4fWz/cp1qezLZvGpDt2wDc/24/ip4bMZ4IMqLiKt3RKegGzoEgQd2qdg/c1F7cyKAU0e6WnQt1ZPJ1eqGaULgB+AV7VjmyqVUnQfKJPJFMOgpeXFh8DwHnGLh4Mz7H3soIcDuBo2afdlc7UTdTKu6u6UyMDWK42zjaRSbUaqCdQqGaajLyvccKBWvfjFn8eOvJAIY6NlTa2i0L5uvm2GYaUCUKpmdYkndeKhyGSlPYKwuIsMyAXEBjIXguTY4VwubZj+w4sNEAEIINNS3r6smP2F5ysqoIIRQ4EKA7zjAGbumAqFUSS+poiCAiEVyBoBTKq2Z07qiMxGA/NHgkb2brWx+fTqTrSwhRN2KUu54AZGTD6trWs6AiMl9IFTvnVLBs53iknmtT51IDHDqcNezaavmWytTo/pfrmXVbQjheEOS5pMB5TYkAaQyEY9UC/LAbZm55MlSYoCh3t23EyM9kM3XTVAbkTQckRnL4JUBcG0XjLekWIkQiqNXdsxevOL1GwWvWPhmH8efnTz0/fuZXN3GVNqypNTS9TFAVYC4BTnnKrgyoF0atu3CyualK/v/N4A8oG/vV/cJQZowxfWE6hYmiCCOkEACg0CICyGfAUeiiDm6QEO/Z/7y538dK72/ABTA1D8jrLJhAAAAAElFTkSuQmCC",
              id: 248,
              index: 2,
              title: "/New TODO",
              url: "https://www.notion.so/matthewbf/New-TODO-6230223ec8dd4ca7aad23c69c6e41a26",
              windowId: 236,
              indexPosition: 100000,
              savedOn: "2021-12-06T01:13:46.721Z",
            },
            {
              pinned: false,
              _id: "61ad63cafa4c7b40b81fa18f",
              active: true,
              favIconUrl: "http://localhost:3001/favicon.ico",
              id: 530,
              index: 3,
              title: "New Collection | Partizion",
              url: "http://localhost:3001/new",
              windowId: 236,
              indexPosition: 100001,
              savedOn: "2021-12-06T01:13:46.721Z",
            },
            {
              pinned: false,
              _id: "61ad63cafa4c7b40b81fa191",
              active: false,
              favIconUrl: "https://developer.mozilla.org/favicon-48x48.97046865.png",
              id: 712,
              index: 5,
              title: "GlobalEventHandlers.onclick - Web APIs | MDN",
              url: "https://developer.mozilla.org/en-US/docs/Web/API/GlobalEventHandlers/onclick",
              windowId: 236,
              indexPosition: 100003,
              savedOn: "2021-12-06T01:13:46.722Z",
            },
          ],
          workspace: "61abdead5577261668b49c5f",
          userId: "619a9ae92f709e693cdc9d82",
          urlId: "h-9rdDuCM",
          indexPosition: 10,
          createdOn: "2021-12-06T01:13:46.722Z",
          lastEdited: "2021-12-06T01:13:46.722Z",
          properties: [],
          __v: 0,
          indexUpdatedOn: "2021-12-06T02:46:07.076Z",
        },
        {
          _id: "61ad63e9fa4c7b40b81fa192",
          name: "save from /new teeheeeee",
          tabs: [
            {
              pinned: false,
              _id: "61ad63e9fa4c7b40b81fa194",
              active: false,
              favIconUrl:
                "data:image/png;base64,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",
              id: 248,
              index: 2,
              title: "/New TODO",
              url: "https://www.notion.so/matthewbf/New-TODO-6230223ec8dd4ca7aad23c69c6e41a26",
              windowId: 236,
              indexPosition: 100000,
              savedOn: "2021-12-06T01:14:17.527Z",
            },
            {
              pinned: false,
              _id: "61ad63e9fa4c7b40b81fa195",
              active: true,
              favIconUrl: "http://localhost:3001/favicon.ico",
              id: 530,
              index: 3,
              title: "New Collection | Partizion",
              url: "http://localhost:3001/new",
              windowId: 236,
              indexPosition: 100001,
              savedOn: "2021-12-06T01:14:17.527Z",
            },
            {
              pinned: false,
              _id: "61ad63e9fa4c7b40b81fa196",
              active: false,
              favIconUrl: "https://mui.com/static/favicon.ico",
              id: 639,
              index: 4,
              title: "Button API - MUI",
              url: "https://mui.com/api/button/",
              windowId: 236,
              indexPosition: 100002,
              savedOn: "2021-12-06T01:14:17.527Z",
            },
            {
              pinned: false,
              _id: "61ad63e9fa4c7b40b81fa197",
              active: false,
              favIconUrl: "https://developer.mozilla.org/favicon-48x48.97046865.png",
              id: 712,
              index: 5,
              title: "GlobalEventHandlers.onclick - Web APIs | MDN",
              url: "https://developer.mozilla.org/en-US/docs/Web/API/GlobalEventHandlers/onclick",
              windowId: 236,
              indexPosition: 100003,
              savedOn: "2021-12-06T01:14:17.527Z",
            },
          ],
          workspace: "61abdead5577261668b49c5f",
          userId: "619a9ae92f709e693cdc9d82",
          urlId: "Le0a1ryqn",
          indexPosition: 11,
          createdOn: "2021-12-06T01:14:17.528Z",
          lastEdited: "2021-12-06T01:14:17.528Z",
          properties: [],
          __v: 0,
          indexUpdatedOn: "2021-12-06T02:46:07.076Z",
        },
        {
          _id: "61ad645dfa4c7b40b81fa198",
          name: "okay go to collection link",
          tabs: [
            {
              pinned: false,
              _id: "61ad645dfa4c7b40b81fa199",
              active: false,
              favIconUrl: "",
              id: 550,
              index: 1,
              title: "Extensions",
              url: "chrome://extensions/",
              windowId: 236,
              indexPosition: 99999,
              savedOn: "2021-12-06T01:16:13.971Z",
            },
            {
              pinned: false,
              _id: "61ad645dfa4c7b40b81fa19a",
              active: false,
              favIconUrl:
                "data:image/png;base64,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",
              id: 248,
              index: 2,
              title: "/New TODO",
              url: "https://www.notion.so/matthewbf/New-TODO-6230223ec8dd4ca7aad23c69c6e41a26",
              windowId: 236,
              indexPosition: 100000,
              savedOn: "2021-12-06T01:16:13.972Z",
            },
            {
              pinned: false,
              _id: "61ad645dfa4c7b40b81fa19b",
              active: true,
              favIconUrl: "http://localhost:3001/favicon.ico",
              id: 530,
              index: 3,
              title: "New Collection | Partizion",
              url: "http://localhost:3001/new",
              windowId: 236,
              indexPosition: 100001,
              savedOn: "2021-12-06T01:16:13.972Z",
            },
            {
              pinned: false,
              _id: "61ad645dfa4c7b40b81fa19c",
              active: false,
              favIconUrl: "https://mui.com/static/favicon.ico",
              id: 639,
              index: 4,
              title: "Button API - MUI",
              url: "https://mui.com/api/button/",
              windowId: 236,
              indexPosition: 100002,
              savedOn: "2021-12-06T01:16:13.972Z",
            },
            {
              pinned: false,
              _id: "61ad645dfa4c7b40b81fa19d",
              active: false,
              favIconUrl: "https://developer.mozilla.org/favicon-48x48.97046865.png",
              id: 712,
              index: 5,
              title: "GlobalEventHandlers.onclick - Web APIs | MDN",
              url: "https://developer.mozilla.org/en-US/docs/Web/API/GlobalEventHandlers/onclick",
              windowId: 236,
              indexPosition: 100003,
              savedOn: "2021-12-06T01:16:13.973Z",
            },
          ],
          workspace: "61abdead5577261668b49c5f",
          userId: "619a9ae92f709e693cdc9d82",
          urlId: "vYVrNQYMa",
          indexPosition: 12,
          createdOn: "2021-12-06T01:16:13.973Z",
          lastEdited: "2021-12-06T01:16:13.973Z",
          properties: [],
          __v: 0,
          indexUpdatedOn: "2021-12-06T02:46:07.076Z",
        },
        {
          _id: "61ad69e6fa4c7b40b81fa1b1",
          name: "LETTS GOOO save this ish",
          tabs: [
            {
              pinned: false,
              _id: "61ad69e6fa4c7b40b81fa1b2",
              active: true,
              favIconUrl: "http://localhost:3001/favicon.ico",
              id: 729,
              index: 2,
              title: "New Collection | Partizion",
              url: "http://localhost:3001/new",
              windowId: 236,
              indexPosition: 99999,
              savedOn: "2021-12-06T01:39:50.841Z",
            },
            {
              pinned: false,
              _id: "61ad69e6fa4c7b40b81fa1b3",
              active: false,
              favIconUrl: "https://www.google.com/a/cpanel/stonks.com/images/favicon.ico",
              id: 736,
              index: 3,
              title: "Inbox (4) - matthew@stonks.com - Stonks Mail",
              url: "https://mail.google.com/mail/u/2/#inbox",
              windowId: 236,
              indexPosition: 100000,
              savedOn: "2021-12-06T01:39:50.842Z",
            },
          ],
          workspace: "61abdead5577261668b49c5f",
          userId: "619a9ae92f709e693cdc9d82",
          urlId: "m0Zg4ppHJ",
          indexPosition: 13,
          createdOn: "2021-12-06T01:39:50.842Z",
          lastEdited: "2021-12-06T01:39:50.842Z",
          properties: [],
          __v: 0,
          indexUpdatedOn: "2021-12-06T02:46:07.076Z",
        },
        {
          _id: "61ad6a0ffa4c7b40b81fa1b4",
          name: "okay save from selected",
          tabs: [
            {
              pinned: false,
              _id: "61ad6a0ffa4c7b40b81fa1b5",
              active: false,
              favIconUrl: "https://ssl.gstatic.com/docs/documents/images/kix-favicon7.ico",
              id: 755,
              index: 5,
              title: "$1,250,000 Team Bonus plan - Google Docs",
              url: "https://docs.google.com/document/d/1rUpg1M9PPkeUOBHGQ7uL52uvk5EdxMRAbeWPBXFXtU8/edit",
              windowId: 236,
              indexPosition: 99999,
              savedOn: "2021-12-06T01:40:31.481Z",
            },
            {
              pinned: false,
              _id: "61ad6a0ffa4c7b40b81fa1b6",
              active: false,
              favIconUrl: "https://ssl.gstatic.com/docs/spreadsheets/favicon3.ico",
              id: 562,
              index: 4,
              title: "Partizion Growth Plan - Google Sheets",
              url: "https://docs.google.com/spreadsheets/d/1eSR0qilr9jw3xb3y75_KRKbzKs9NMtEHI6w0rj6prx4/edit?pli=1#gid=0",
              windowId: 554,
              indexPosition: 100000,
              savedOn: "2021-12-06T01:40:31.481Z",
            },
            {
              pinned: false,
              _id: "61ad6a0ffa4c7b40b81fa1b7",
              active: false,
              favIconUrl: "https://stonks.com/favicon.ico",
              id: 567,
              index: 5,
              title: "Stonks — YC demo day for everyone",
              url: "https://stonks.com/dashboard/events/events",
              windowId: 554,
              indexPosition: 100001,
              savedOn: "2021-12-06T01:40:31.482Z",
            },
          ],
          workspace: "61abdead5577261668b49c5f",
          userId: "619a9ae92f709e693cdc9d82",
          urlId: "ZqaiPaoKT",
          indexPosition: 14,
          createdOn: "2021-12-06T01:40:31.482Z",
          lastEdited: "2021-12-06T01:40:31.482Z",
          properties: [],
          __v: 0,
          indexUpdatedOn: "2021-12-06T02:46:07.076Z",
        },
        {
          _id: "61ad7309fa4c7b40b81fa1c4",
          name: "My new collection",
          tabs: [
            {
              pinned: false,
              _id: "61ad7309fa4c7b40b81fa1c5",
              active: false,
              favIconUrl: "https://staging.stonks.com/favicon.ico",
              id: 569,
              index: 7,
              title: "Stonks — YC demo day for everyone",
              url: "https://staging.stonks.com/",
              windowId: 554,
              indexPosition: 99999,
              savedOn: "2021-12-06T02:18:49.375Z",
            },
          ],
          properties: [],
          workspace: "61abdead5577261668b49c5f",
          userId: "619a9ae92f709e693cdc9d82",
          urlId: "LQ1XVHnDE",
          indexPosition: 15,
          createdOn: "2021-12-06T02:18:49.375Z",
          lastEdited: "2021-12-06T02:18:49.375Z",
          __v: 0,
          indexUpdatedOn: "2021-12-06T02:46:07.076Z",
        },
        {
          _id: "61ad7317fa4c7b40b81fa1c6",
          name: "asdfasdf",
          tabs: [
            {
              pinned: false,
              _id: "61ad7317fa4c7b40b81fa1c7",
              active: false,
              favIconUrl: "https://www.google.com/favicon.ico",
              id: 571,
              index: 8,
              title: "Sign in - Google Accounts",
              url: "https://accounts.google.com/o/oauth2/v2/auth/oauthchooseaccount?access_type=online&login_hint=matthew%40stonks.com&scope=openid%20email%20profile&response_type=code&redirect_uri=https%3A%2F%2Fapp.logdna.com%2Fauth%2Fgooglesignin&state=e553a9e6959b819436fc6c9f4e8566cfedaad7ab1854d14e1cb1001cfc2f3042901cac01a9ae2cbebf47a8f194e40a50d48df845193c4ab5ca&prompt=select_account&client_id=235929664937-8fhm3jfrgn11hrq50a09r1587gsrbn7p.apps.googleusercontent.com&hd=stonks.com&as=S-184281579%3A1638739026132205&flowName=GeneralOAuthFlow",
              windowId: 554,
              indexPosition: 99999,
              savedOn: "2021-12-06T02:19:03.406Z",
            },
          ],
          properties: [],
          workspace: "61abdead5577261668b49c5f",
          userId: "619a9ae92f709e693cdc9d82",
          urlId: "xmTau_uVe",
          indexPosition: 16,
          createdOn: "2021-12-06T02:19:03.406Z",
          lastEdited: "2021-12-06T02:19:03.406Z",
          __v: 0,
          indexUpdatedOn: "2021-12-06T02:46:07.076Z",
        },
        {
          _id: "61ad7380fa4c7b40b81fa1c8",
          name: "my nw fodskl;fjklfsa",
          tabs: [
            {
              pinned: false,
              _id: "61ad7380fa4c7b40b81fa1c9",
              active: true,
              favIconUrl: "http://localhost:3001/favicon.ico",
              id: 794,
              index: 2,
              title: "Partizion Dashboard",
              url: "http://localhost:3001/61abdead5577261668b49c5f",
              windowId: 236,
              indexPosition: 99999,
              savedOn: "2021-12-06T02:20:48.111Z",
            },
          ],
          properties: [],
          workspace: "61abdead5577261668b49c5f",
          userId: "619a9ae92f709e693cdc9d82",
          urlId: "f7Mjs7_I7",
          indexPosition: 17,
          createdOn: "2021-12-06T02:20:48.111Z",
          lastEdited: "2021-12-06T02:20:48.111Z",
          __v: 0,
          indexUpdatedOn: "2021-12-06T02:46:07.076Z",
        },
      ],
    },
    {
      _id: "61ad6e66fa4c7b40b81fa1bc",
      icon: {
        emoticons: [],
        short_names: [],
      },
      name: "ONE",
      userId: "619a9ae92f709e693cdc9d82",
      indexPosition: 3,
      createdOn: "2021-12-06T01:59:02.938Z",
      collectionProperties: [],
      __v: 0,
      activeView: "61ad756bfa4c7b40b81fa204",
      indexUpdatedOn: "2021-12-06T02:46:59.803Z",
      collections: [
        {
          _id: "61ad73aafa4c7b40b81fa1ca",
          name: "YEEEEEEt",
          tabs: [
            {
              pinned: false,
              savedOn: "2021-12-06T02:21:30.362Z",
              _id: "61ad73aafa4c7b40b81fa1cb",
              active: false,
              favIconUrl: "https://mui.com/static/favicon.ico",
              id: 797,
              index: 2,
              title: "Tab API - MUI",
              url: "https://mui.com/api/tab/",
              windowId: 236,
              indexPosition: 0,
            },
            {
              pinned: false,
              _id: "61bbbcd7c97b9323ee099387",
              savedOn: "2021-12-16T22:25:27.340Z",
              active: false,
              favIconUrl: "https://ssl.gstatic.com/docs/spreadsheets/favicon3.ico",
              id: 264,
              index: 4,
              title: "Partizion Growth Plan - Google Sheets",
              url: "https://docs.google.com/spreadsheets/d/1eSR0qilr9jw3xb3y75_KRKbzKs9NMtEHI6w0rj6prx4/edit?pli=1#gid=0",
              windowId: 245,
              indexPosition: 2,
              indexUpdatedOn: "2021-12-16T22:38:07.284Z",
            },
          ],
          properties: [],
          workspace: "61ad6e66fa4c7b40b81fa1bc",
          userId: "619a9ae92f709e693cdc9d82",
          urlId: "xQ_mUi1nR",
          indexPosition: 0,
          createdOn: "2021-12-06T02:21:30.362Z",
          lastEdited: "2021-12-16T22:38:07.285Z",
          __v: 15,
          indexUpdatedOn: "2021-12-16T22:38:08.404Z",
        },
        {
          _id: "61bbbcd7c97b9323ee099385",
          name: "UNO",
          tabs: [
            {
              pinned: false,
              savedOn: "2021-12-16T22:25:27.340Z",
              _id: "61bbbcd7c97b9323ee099386",
              active: false,
              favIconUrl: "https://www.google.com/a/cpanel/stonks.com/images/favicon.ico",
              id: 255,
              index: 1,
              title: "Inbox (5) - matthew@stonks.com - Stonks Mail",
              url: "https://mail.google.com/mail/u/2/#inbox",
              windowId: 245,
              indexPosition: 0,
            },
            {
              pinned: false,
              savedOn: "2021-12-16T22:25:42.534Z",
              _id: "61bbbce6c97b9323ee09938a",
              active: false,
              favIconUrl: "https://github.githubassets.com/favicons/favicon.svg",
              id: 258,
              index: 2,
              title: "Stonks",
              url: "https://github.com/stonkscom",
              windowId: 245,
              indexPosition: 1,
              indexUpdatedOn: "2021-12-16T22:38:05.882Z",
            },
            {
              pinned: false,
              _id: "61bbbcdec97b9323ee099388",
              savedOn: "2021-12-16T22:25:34.038Z",
              active: false,
              favIconUrl: "https://ssl.gstatic.com/docs/spreadsheets/favicon3.ico",
              id: 292,
              index: 10,
              title: "Startup Signups - Google Sheets",
              url: "https://docs.google.com/spreadsheets/d/1Kfai0lnT96D7B7vzi_2auhZLsL5zqRrg_PY-Wf92Wn8/edit#gid=328970603",
              windowId: 274,
              indexPosition: 2,
              indexUpdatedOn: "2021-12-16T22:38:09.888Z",
            },
          ],
          properties: [],
          workspace: "61ad6e66fa4c7b40b81fa1bc",
          userId: "619a9ae92f709e693cdc9d82",
          urlId: "uIZcJcmn5",
          indexPosition: 1,
          createdOn: "2021-12-16T22:25:27.340Z",
          lastEdited: "2021-12-16T22:38:09.889Z",
          __v: 14,
          indexUpdatedOn: "2021-12-16T22:38:08.404Z",
        },
        {
          _id: "61c4de8c1422260408724789",
          name: "Copy of Copy of hello mate 989",
          urlId: "P1bD13lDA",
          userId: "619a9ae92f709e693cdc9d82",
          workspace: "61ad6e66fa4c7b40b81fa1bc",
          tabs: [
            {
              pinned: false,
              _id: "61c4dc321422260408724772",
              active: false,
              favIconUrl: "https://airtable.com/images/favicon/baymax/favicon-32x32.png",
              id: 320,
              index: 5,
              title: "Sign in - Airtable",
              url: "https://airtable.com/login?continue=%2Fappa18HZnmBAosioj%2FtblIyg6q9C38sbMxz%2FviwK9YYbVExbY0LT7%3Fblocks%3Dhide",
              windowId: 304,
              indexPosition: 99999,
              savedOn: "2021-12-23T20:29:38.975Z",
            },
            {
              pinned: false,
              _id: "61c4dc321422260408724773",
              active: false,
              favIconUrl: "https://stonks.com/favicon.ico",
              id: 360,
              index: 2,
              title: "Demo Days | Stonks",
              url: "https://stonks.com/dashboard/xoogler/events",
              windowId: 155,
              indexPosition: 100000,
              savedOn: "2021-12-23T20:29:38.976Z",
            },
          ],
          indexPosition: 9999999,
          properties: [],
          createdOn: "2021-12-23T20:39:40.689Z",
          lastEdited: "2021-12-23T20:39:40.689Z",
          __v: 0,
          indexUpdatedOn: "2021-12-23T20:39:46.545Z",
        },
        {
          _id: "61c4dc7c1422260408724783",
          name: "Copy of hello mate 989",
          urlId: "dLkRIYIuq",
          userId: "619a9ae92f709e693cdc9d82",
          workspace: "61ad6e66fa4c7b40b81fa1bc",
          tabs: [
            {
              pinned: false,
              _id: "61c4dc321422260408724772",
              active: false,
              favIconUrl: "https://airtable.com/images/favicon/baymax/favicon-32x32.png",
              id: 320,
              index: 5,
              title: "Sign in - Airtable",
              url: "https://airtable.com/login?continue=%2Fappa18HZnmBAosioj%2FtblIyg6q9C38sbMxz%2FviwK9YYbVExbY0LT7%3Fblocks%3Dhide",
              windowId: 304,
              indexPosition: 99999,
              savedOn: "2021-12-23T20:29:38.975Z",
            },
            {
              pinned: false,
              _id: "61c4dc321422260408724773",
              active: false,
              favIconUrl: "https://stonks.com/favicon.ico",
              id: 360,
              index: 2,
              title: "Demo Days | Stonks",
              url: "https://stonks.com/dashboard/xoogler/events",
              windowId: 155,
              indexPosition: 100000,
              savedOn: "2021-12-23T20:29:38.976Z",
            },
          ],
          indexPosition: 9999999,
          properties: [],
          createdOn: "2021-12-23T20:30:52.165Z",
          lastEdited: "2021-12-23T20:30:52.165Z",
          __v: 0,
        },
      ],
    },
    {
      _id: "61ad6e69fa4c7b40b81fa1bd",
      icon: {
        emoticons: [],
        short_names: [],
      },
      name: "TWO",
      userId: "619a9ae92f709e693cdc9d82",
      indexPosition: 4,
      createdOn: "2021-12-06T01:59:05.048Z",
      collectionProperties: [],
      __v: 0,
      activeView: "61c66507d65dfc241df63905",
      indexUpdatedOn: "2021-12-06T02:46:59.803Z",
      collections: [
        {
          _id: "61ad73bcfa4c7b40b81fa1ce",
          name: "Copy of sadfadsfa",
          urlId: "hffTg4sDZ",
          userId: "619a9ae92f709e693cdc9d82",
          workspace: "61ad6e69fa4c7b40b81fa1bd",
          tabs: [
            {
              pinned: false,
              _id: "61ad73cefa4c7b40b81fa1d5",
              active: false,
              favIconUrl: "https://ssl.gstatic.com/docs/documents/images/kix-favicon7.ico",
              id: 560,
              index: 2,
              title: "$1,250,000 Team Bonus plan - Google Docs",
              url: "https://docs.google.com/document/d/1rUpg1M9PPkeUOBHGQ7uL52uvk5EdxMRAbeWPBXFXtU8/edit",
              windowId: 554,
              indexPosition: 1000000,
              savedOn: "2021-12-06T02:22:06.180Z",
            },
            {
              pinned: false,
              _id: "61ad73cefa4c7b40b81fa1d6",
              active: false,
              favIconUrl:
                "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAzZJREFUWEftl21IU2EUx//Xu003m9t8L6dOl0Wahh8qSwOzjIJIKDIRQTKSyiL6UqBSoBn4rcgwC/SDflArykgK7Q16oTcTNDRfc1lTm+9zWdPtxr3q2p136pJpYc+XC/ee55zfPec855yHAADvCy0eegOVQQC7KUBJv7PXIoA2CrgnIImc7vQgDTFp/AWAIHsZtaK3RUASkYRrdvNFACcX2PiUuUuEW3Zzq73dbu3n6HDQHqBs+Xs/KR9igQPnlhG9EarBMVvUwSaAtAgZsra7z2jg3MNe5L0amDOETQD5cd6IDxWj4ZseXdpxlhHPZSRCvRxR0TiClFtd9gVIKFWjulXHMhKlEKIiSb5EAAZGDdAb2LkrIAnIhKR9PRC70hnF8ctBEgTjfoeJB4yTLONGCscqenC7QWufHLDUqjqtZGDkua1zNmgpaNMpWHoAMYEiyCV8q+7N3enBfDvzQGNVpls7jiqLI2subDUEHs4kPp4K/OPYmm8Mz+vAZysl2iqAQsZHTZoCGp0B5fXDnCCpG6RMEua/5i69cWvEkEt4iCpQoVGj59QxK8DzjlHElXzh3DzbKbiZ6IOtgaL/ALZ5QOpEIiFMDG8xDyc2yZj+XlQzhCaNnslmuvodCHOBu4hEerQb6KKY86QPwz+NKK4dYqriNqUIwZ6OSA6XIMCVj8J3Q2gf0KOsTov+UQMrnNNyoDJZjghfIWfM113+hH0hYpyN4Z4JMqs1qGzSofa4gnM/Vz5NA3h5xB+r3QXIedpnUpIQ5gKlKx87ijqxf60Yh9dLcb9Zh/fqH4xMpL8Q0QEiXH87iBsftKg66Iu2/jGU1v0+PRnRbmjq1WPzVdXMHpgCcDvfYhIsiV+BXaucWQBpd3tMBmjAK3u8WAA0YFK52qSjLzPoHwF4luqPYE8B6NY6tXiTfTe2sBN7Q8Q4ulHKJJuRmpBxIAgmOQveDDJF69EhP9BfDBY66FFuy7VZQkAnGT140krN19fhMSYEvhI+7iT5wInHnoy/jxmRWKZm3Fyd4gu5C7uHGCgKWY97UV7PnhXm1Y7n3SgIUH/FxWRxr2aLfjml47hg13M65hTaza/nvwCegssyiLThjAAAAABJRU5ErkJggg==",
              id: 561,
              index: 3,
              title: "Partizion: Growth Ideas - Airtable",
              url: "https://airtable.com/app1xlaKM2ul6Oyyf/tblapIt6RxKkmSRSH/viwBCoBoG1LBtgl6p?blocks=hide",
              windowId: 554,
              indexPosition: 1000001,
              savedOn: "2021-12-06T02:22:06.181Z",
            },
            {
              pinned: false,
              _id: "61ad73cefa4c7b40b81fa1d7",
              active: false,
              favIconUrl: "https://ssl.gstatic.com/docs/spreadsheets/favicon3.ico",
              id: 562,
              index: 4,
              title: "Partizion Growth Plan - Google Sheets",
              url: "https://docs.google.com/spreadsheets/d/1eSR0qilr9jw3xb3y75_KRKbzKs9NMtEHI6w0rj6prx4/edit?pli=1#gid=0",
              windowId: 554,
              indexPosition: 1000002,
              savedOn: "2021-12-06T02:22:06.181Z",
            },
            {
              pinned: false,
              _id: "61ad73cefa4c7b40b81fa1d8",
              active: false,
              favIconUrl: "https://stonks.com/favicon.ico",
              id: 567,
              index: 5,
              title: "Stonks — YC demo day for everyone",
              url: "https://stonks.com/dashboard/events/events",
              windowId: 554,
              indexPosition: 1000003,
              savedOn: "2021-12-06T02:22:06.181Z",
            },
            {
              pinned: false,
              _id: "61ad73cefa4c7b40b81fa1d9",
              active: false,
              favIconUrl: "https://stonks.com/favicon.ico",
              id: 568,
              index: 6,
              title: "Stonks Events | Stonks",
              url: "https://stonks.com/events",
              windowId: 554,
              indexPosition: 1000004,
              savedOn: "2021-12-06T02:22:06.182Z",
            },
            {
              pinned: false,
              _id: "61ad73cefa4c7b40b81fa1da",
              active: false,
              favIconUrl: "https://dev.stonks.com/favicon.ico",
              id: 570,
              index: 7,
              title: "Stonks — YC demo day for everyone",
              url: "https://dev.stonks.com/",
              windowId: 554,
              indexPosition: 1000005,
              savedOn: "2021-12-06T02:22:06.182Z",
            },
            {
              pinned: false,
              _id: "61ad73cefa4c7b40b81fa1db",
              active: false,
              favIconUrl: "https://ssl.gstatic.com/docs/spreadsheets/favicon3.ico",
              id: 572,
              index: 8,
              title: "Startup Signups - Google Sheets",
              url: "https://docs.google.com/spreadsheets/d/1Kfai0lnT96D7B7vzi_2auhZLsL5zqRrg_PY-Wf92Wn8/edit#gid=328970603",
              windowId: 554,
              indexPosition: 1000006,
              savedOn: "2021-12-06T02:22:06.183Z",
            },
            {
              pinned: false,
              _id: "61ad73cefa4c7b40b81fa1dc",
              active: false,
              favIconUrl: "http://principal-api.stonks.com/favicon.ico",
              id: 573,
              index: 9,
              title: "Stonks API",
              url: "http://principal-api.stonks.com/",
              windowId: 554,
              indexPosition: 1000007,
              savedOn: "2021-12-06T02:22:06.183Z",
            },
            {
              pinned: false,
              _id: "61ad73cefa4c7b40b81fa1dd",
              active: false,
              favIconUrl:
                "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAztJREFUWEftV21IU2EUfu6cd875sQ+XIla6uTQtLbQMtQ+M0kSlEIKKCgWpoOhH+CuKCPqTfwqCiKAwsA8orDTDviBD11AhofJzpmnT0G2mzrl5d2+8l5Sp7aYL9c/Or3vf855znvd5D+c9hwKAoJpYNe1gz3NAHgAtWVtCMVJAtVMiujKe2zVE8cEn2XqOgm4Jg85zTXHodAaIMihlpeYaB5xdzuDTsSjgOqWo1HQtA+2ezmckADhP2vCAVQgSy2CyD8Lusi+KJCUth4JWgGEZ9E70ebQVBNCV2wQlreCNOXBwsk702PpQbapFec9D9NtNvG5t4GqcjC3CnvBdCJeoESiWggLF66zOEWhrUrwDYMxthpwOxdfRdsj9Q6GWqECL6BlnLSNf+O9keeLMGgFpdlphcVqRGBK/eAASEY28yGzQIn+UJV+GmBIj4nn8TIAwiRKntMUo0Rzjr4fIOGPD7e57uGm8g2GHZWbvYEEbGI5BactFTLEMXg6+gY2ZmMXGvCuoyryPjLA0txNNzQIwrRBRIpjyCQMUIqsSwHLsPJoJAHKQaXk/1IAD9UeFARh2v4IuWItb3eUoij7EB3BnwN26P/8z/xtVteGvd0wAkOy52/MAJzTH0TlmRNrbvQsDoHyqBckBmVj2XwBsjI1PQst+ow+AjwEfAz4GvGOAPEZNlk8YmPyJH3YTagffoW5Iz1cz90pISnNORBY2yZOwLliDKGkkNiuSMOL85X0has3Rg/QEc4U8LK1jHdgYuh4ujkXbaAcSQuJAQMwV8jLqalK9q4TEmdRPChWtQIxsDbaqUpCu2oI0VSoC/aSzYk247NAPN0JvboTB0oxvtl6YHVY4WAe/z6tS7LGLAFAccwRXky7xW861XOAbFCFZNICy9huCDj+am6ANioaLc6HX1o80leeuhzgqjTu9sCR8llmB7WHbBIMTJcmD7LpCvvWq3fkEYsrvnzYGczP2fTgo/ByTZrIwqkDQ4Q51OrIjsmY5ejHwGg3DBo8gpjgGj75XYowZFwbwz2P82XBGV4Ki6MMgyVfR+5hvx7wRwa7YG4eLtOFWfjBZ8dFsxYdTcmfLOJ6TMbDbfTz/Db6BOK4bvgYdAAAAAElFTkSuQmCC",
              id: 576,
              index: 10,
              title: "Reading List: Reading List - Airtable",
              url: "https://airtable.com/appa18HZnmBAosioj/tblIyg6q9C38sbMxz/viwK9YYbVExbY0LT7?blocks=hide",
              windowId: 554,
              indexPosition: 1000008,
              savedOn: "2021-12-06T02:22:06.183Z",
            },
          ],
          indexPosition: 0,
          properties: [],
          createdOn: "2021-12-06T02:21:48.303Z",
          lastEdited: "2021-12-06T02:22:06.184Z",
          __v: 2,
          indexUpdatedOn: "2021-12-06T02:22:23.368Z",
        },
        {
          _id: "61ad73d4fa4c7b40b81fa1de",
          name: "Tabs from Dec 5, 2021 7:22 PM",
          tabs: [
            {
              pinned: false,
              _id: "61ad73d4fa4c7b40b81fa1df",
              active: false,
              favIconUrl: "https://ssl.gstatic.com/docs/documents/images/kix-favicon7.ico",
              id: 560,
              index: 2,
              title: "$1,250,000 Team Bonus plan - Google Docs",
              url: "https://docs.google.com/document/d/1rUpg1M9PPkeUOBHGQ7uL52uvk5EdxMRAbeWPBXFXtU8/edit",
              windowId: 554,
              indexPosition: 99999,
              savedOn: "2021-12-06T02:22:12.390Z",
            },
            {
              pinned: false,
              _id: "61ad73d4fa4c7b40b81fa1e0",
              active: false,
              favIconUrl:
                "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAzZJREFUWEftl21IU2EUx//Xu003m9t8L6dOl0Wahh8qSwOzjIJIKDIRQTKSyiL6UqBSoBn4rcgwC/SDflArykgK7Q16oTcTNDRfc1lTm+9zWdPtxr3q2p136pJpYc+XC/ee55zfPec855yHAADvCy0eegOVQQC7KUBJv7PXIoA2CrgnIImc7vQgDTFp/AWAIHsZtaK3RUASkYRrdvNFACcX2PiUuUuEW3Zzq73dbu3n6HDQHqBs+Xs/KR9igQPnlhG9EarBMVvUwSaAtAgZsra7z2jg3MNe5L0amDOETQD5cd6IDxWj4ZseXdpxlhHPZSRCvRxR0TiClFtd9gVIKFWjulXHMhKlEKIiSb5EAAZGDdAb2LkrIAnIhKR9PRC70hnF8ctBEgTjfoeJB4yTLONGCscqenC7QWufHLDUqjqtZGDkua1zNmgpaNMpWHoAMYEiyCV8q+7N3enBfDvzQGNVpls7jiqLI2subDUEHs4kPp4K/OPYmm8Mz+vAZysl2iqAQsZHTZoCGp0B5fXDnCCpG6RMEua/5i69cWvEkEt4iCpQoVGj59QxK8DzjlHElXzh3DzbKbiZ6IOtgaL/ALZ5QOpEIiFMDG8xDyc2yZj+XlQzhCaNnslmuvodCHOBu4hEerQb6KKY86QPwz+NKK4dYqriNqUIwZ6OSA6XIMCVj8J3Q2gf0KOsTov+UQMrnNNyoDJZjghfIWfM113+hH0hYpyN4Z4JMqs1qGzSofa4gnM/Vz5NA3h5xB+r3QXIedpnUpIQ5gKlKx87ijqxf60Yh9dLcb9Zh/fqH4xMpL8Q0QEiXH87iBsftKg66Iu2/jGU1v0+PRnRbmjq1WPzVdXMHpgCcDvfYhIsiV+BXaucWQBpd3tMBmjAK3u8WAA0YFK52qSjLzPoHwF4luqPYE8B6NY6tXiTfTe2sBN7Q8Q4ulHKJJuRmpBxIAgmOQveDDJF69EhP9BfDBY66FFuy7VZQkAnGT140krN19fhMSYEvhI+7iT5wInHnoy/jxmRWKZm3Fyd4gu5C7uHGCgKWY97UV7PnhXm1Y7n3SgIUH/FxWRxr2aLfjml47hg13M65hTaza/nvwCegssyiLThjAAAAABJRU5ErkJggg==",
              id: 561,
              index: 3,
              title: "Partizion: Growth Ideas - Airtable",
              url: "https://airtable.com/app1xlaKM2ul6Oyyf/tblapIt6RxKkmSRSH/viwBCoBoG1LBtgl6p?blocks=hide",
              windowId: 554,
              indexPosition: 100000,
              savedOn: "2021-12-06T02:22:12.390Z",
            },
            {
              pinned: false,
              _id: "61ad73d4fa4c7b40b81fa1e2",
              active: false,
              favIconUrl: "https://stonks.com/favicon.ico",
              id: 567,
              index: 5,
              title: "Stonks — YC demo day for everyone",
              url: "https://stonks.com/dashboard/events/events",
              windowId: 554,
              indexPosition: 100002,
              savedOn: "2021-12-06T02:22:12.391Z",
            },
            {
              pinned: false,
              _id: "61ad73d4fa4c7b40b81fa1e3",
              active: false,
              favIconUrl: "https://stonks.com/favicon.ico",
              id: 568,
              index: 6,
              title: "Stonks Events | Stonks",
              url: "https://stonks.com/events",
              windowId: 554,
              indexPosition: 100003,
              savedOn: "2021-12-06T02:22:12.391Z",
            },
            {
              pinned: false,
              _id: "61ad73d4fa4c7b40b81fa1e4",
              active: false,
              favIconUrl: "https://dev.stonks.com/favicon.ico",
              id: 570,
              index: 7,
              title: "Stonks — YC demo day for everyone",
              url: "https://dev.stonks.com/",
              windowId: 554,
              indexPosition: 100004,
              savedOn: "2021-12-06T02:22:12.391Z",
            },
            {
              pinned: false,
              _id: "61ad73d4fa4c7b40b81fa1e5",
              active: false,
              favIconUrl: "https://ssl.gstatic.com/docs/spreadsheets/favicon3.ico",
              id: 572,
              index: 8,
              title: "Startup Signups - Google Sheets",
              url: "https://docs.google.com/spreadsheets/d/1Kfai0lnT96D7B7vzi_2auhZLsL5zqRrg_PY-Wf92Wn8/edit#gid=328970603",
              windowId: 554,
              indexPosition: 100005,
              savedOn: "2021-12-06T02:22:12.391Z",
            },
            {
              pinned: false,
              _id: "61ad73d4fa4c7b40b81fa1e6",
              active: false,
              favIconUrl: "http://principal-api.stonks.com/favicon.ico",
              id: 573,
              index: 9,
              title: "Stonks API",
              url: "http://principal-api.stonks.com/",
              windowId: 554,
              indexPosition: 100006,
              savedOn: "2021-12-06T02:22:12.392Z",
            },
            {
              pinned: false,
              _id: "61ad73d4fa4c7b40b81fa1e7",
              active: false,
              favIconUrl:
                "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAztJREFUWEftV21IU2EUfu6cd875sQ+XIla6uTQtLbQMtQ+M0kSlEIKKCgWpoOhH+CuKCPqTfwqCiKAwsA8orDTDviBD11AhofJzpmnT0G2mzrl5d2+8l5Sp7aYL9c/Or3vf855znvd5D+c9hwKAoJpYNe1gz3NAHgAtWVtCMVJAtVMiujKe2zVE8cEn2XqOgm4Jg85zTXHodAaIMihlpeYaB5xdzuDTsSjgOqWo1HQtA+2ezmckADhP2vCAVQgSy2CyD8Lusi+KJCUth4JWgGEZ9E70ebQVBNCV2wQlreCNOXBwsk702PpQbapFec9D9NtNvG5t4GqcjC3CnvBdCJeoESiWggLF66zOEWhrUrwDYMxthpwOxdfRdsj9Q6GWqECL6BlnLSNf+O9keeLMGgFpdlphcVqRGBK/eAASEY28yGzQIn+UJV+GmBIj4nn8TIAwiRKntMUo0Rzjr4fIOGPD7e57uGm8g2GHZWbvYEEbGI5BactFTLEMXg6+gY2ZmMXGvCuoyryPjLA0txNNzQIwrRBRIpjyCQMUIqsSwHLsPJoJAHKQaXk/1IAD9UeFARh2v4IuWItb3eUoij7EB3BnwN26P/8z/xtVteGvd0wAkOy52/MAJzTH0TlmRNrbvQsDoHyqBckBmVj2XwBsjI1PQst+ow+AjwEfAz4GvGOAPEZNlk8YmPyJH3YTagffoW5Iz1cz90pISnNORBY2yZOwLliDKGkkNiuSMOL85X0has3Rg/QEc4U8LK1jHdgYuh4ujkXbaAcSQuJAQMwV8jLqalK9q4TEmdRPChWtQIxsDbaqUpCu2oI0VSoC/aSzYk247NAPN0JvboTB0oxvtl6YHVY4WAe/z6tS7LGLAFAccwRXky7xW861XOAbFCFZNICy9huCDj+am6ANioaLc6HX1o80leeuhzgqjTu9sCR8llmB7WHbBIMTJcmD7LpCvvWq3fkEYsrvnzYGczP2fTgo/ByTZrIwqkDQ4Q51OrIjsmY5ejHwGg3DBo8gpjgGj75XYowZFwbwz2P82XBGV4Ki6MMgyVfR+5hvx7wRwa7YG4eLtOFWfjBZ8dFsxYdTcmfLOJ6TMbDbfTz/Db6BOK4bvgYdAAAAAElFTkSuQmCC",
              id: 576,
              index: 10,
              title: "Reading List: Reading List - Airtable",
              url: "https://airtable.com/appa18HZnmBAosioj/tblIyg6q9C38sbMxz/viwK9YYbVExbY0LT7?blocks=hide",
              windowId: 554,
              indexPosition: 100007,
              savedOn: "2021-12-06T02:22:12.392Z",
            },
          ],
          properties: [],
          workspace: "61ad6e69fa4c7b40b81fa1bd",
          userId: "619a9ae92f709e693cdc9d82",
          urlId: "Yy1TuZPT2",
          indexPosition: 1,
          createdOn: "2021-12-06T02:22:12.392Z",
          lastEdited: "2021-12-06T02:22:12.392Z",
          __v: 0,
          indexUpdatedOn: "2021-12-06T02:22:23.368Z",
        },
        {
          _id: "61ad73b9fa4c7b40b81fa1cd",
          name: "fasdfsaf",
          tabs: [
            {
              pinned: false,
              savedOn: "2021-12-06T02:22:02.860Z",
              _id: "61ad73cafa4c7b40b81fa1d3",
              active: true,
              favIconUrl:
                "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAhBJREFUWEftl79r20AUx9+dZBUJ5F8QbOxmLBS8lIzpkEbFJ3dp/U906h/QwYuH7h08BDx5PzDt0qN2lxYSyBAIBdPSqZS0mNKlBIMt4XfhjGRCLDt2AjYtukXi7v343Fd67yQCGx5kw/nh3wVwXfclIu4QQlCpKKWklmV9zeVyr5rNpr+ssjdWgDF2CAC7YSJEhFQq9cW27Z1WqzVcB8A7AHhyBeCoUCg4jUZjFAPECmxMAUrpPufcWwfAGwB4drkKMpnMR875o2WTK7vIPuC67nMASCKinBeMEKJs7ofrUkowDOM7Ih74vu8TQmZiU0qJlPK80+k0Q79IAMbYXwWwyk6Cbjhxicg9mVeQuq6fCyGmsecBnAFAcVWA6+wDgF9CiGnseQA/AGD7uoCrrgcAZ0KIaexIAMdxfkspt6KkVEHUvKZpM1KrtfF4PJE6yledF4lE4k+3291a+A5Uq9VvmqbdVYGujjD5YDAwPM/TwkTBS4imaY7UfZRvoMBPzvm9hQD1ev2BYRh3oqrAsizo9/vQ6/VeD4fDXaWEGmrn2Wz2c6lUemGapuf7sydyUAWjWq12uhBgmWfrOM5bXdefXu4DyWTyU7vd3lvG/9YAjLH4OI4V2KwC5XL5PSKysA+oJpNOp4+LxeLeWr4JK5XKB0rp47DhqKtt2yf5fP7hWgBWqfVFtjf+L4gB/hsFLgARkyUw/Rnd2AAAAABJRU5ErkJggg==",
              index: 1,
              title: "Valuations",
              url: "https://www.notion.so/stonky/Valuations-44f3d6eae8e346448fcc1f8eb815bc24",
              windowId: 0,
              indexPosition: 0,
            },
            {
              pinned: false,
              savedOn: "2021-12-06T02:22:02.861Z",
              _id: "61ad73cafa4c7b40b81fa1d4",
              active: false,
              favIconUrl: "https://www.investopedia.com/favicon.ico",
              index: 2,
              title: "Pre-Money vs. Post-Money: What's the Difference?",
              url: "https://www.investopedia.com/ask/answers/difference-between-premoney-and-postmoney/",
              windowId: 0,
              indexPosition: 1,
            },
            {
              pinned: false,
              _id: "61ad73d4fa4c7b40b81fa1e1",
              active: false,
              favIconUrl: "https://ssl.gstatic.com/docs/spreadsheets/favicon3.ico",
              id: 562,
              index: 4,
              title: "Partizion Growth Plan - Google Sheets",
              url: "https://docs.google.com/spreadsheets/d/1eSR0qilr9jw3xb3y75_KRKbzKs9NMtEHI6w0rj6prx4/edit?pli=1#gid=0",
              windowId: 554,
              indexPosition: 2,
              savedOn: "2021-12-06T02:22:12.391Z",
              indexUpdatedOn: "2021-12-06T02:22:26.386Z",
            },
          ],
          properties: [],
          workspace: "61ad6e69fa4c7b40b81fa1bd",
          userId: "619a9ae92f709e693cdc9d82",
          urlId: "oFHJxa_tr",
          indexPosition: 2,
          createdOn: "2021-12-06T02:21:45.063Z",
          lastEdited: "2021-12-06T02:22:26.387Z",
          __v: 2,
          indexUpdatedOn: "2021-12-06T02:22:23.368Z",
        },
        {
          _id: "61ad73b5fa4c7b40b81fa1cc",
          name: "sadfadsfa",
          tabs: [
            {
              pinned: false,
              _id: "61ad73c0fa4c7b40b81fa1cf",
              active: false,
              favIconUrl: "https://mui.com/static/favicon.ico",
              id: 807,
              index: 2,
              title: "Tab API - MUI",
              url: "https://mui.com/api/tab/",
              windowId: 236,
              indexPosition: 0,
              savedOn: "2021-12-06T02:21:52.762Z",
              indexUpdatedOn: "2021-12-06T02:21:54.752Z",
            },
            {
              pinned: false,
              _id: "61ad73c8fa4c7b40b81fa1d1",
              active: true,
              favIconUrl:
                "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAhBJREFUWEftl79r20AUx9+dZBUJ5F8QbOxmLBS8lIzpkEbFJ3dp/U906h/QwYuH7h08BDx5PzDt0qN2lxYSyBAIBdPSqZS0mNKlBIMt4XfhjGRCLDt2AjYtukXi7v343Fd67yQCGx5kw/nh3wVwXfclIu4QQlCpKKWklmV9zeVyr5rNpr+ssjdWgDF2CAC7YSJEhFQq9cW27Z1WqzVcB8A7AHhyBeCoUCg4jUZjFAPECmxMAUrpPufcWwfAGwB4drkKMpnMR875o2WTK7vIPuC67nMASCKinBeMEKJs7ofrUkowDOM7Ih74vu8TQmZiU0qJlPK80+k0Q79IAMbYXwWwyk6Cbjhxicg9mVeQuq6fCyGmsecBnAFAcVWA6+wDgF9CiGnseQA/AGD7uoCrrgcAZ0KIaexIAMdxfkspt6KkVEHUvKZpM1KrtfF4PJE6yledF4lE4k+3291a+A5Uq9VvmqbdVYGujjD5YDAwPM/TwkTBS4imaY7UfZRvoMBPzvm9hQD1ev2BYRh3oqrAsizo9/vQ6/VeD4fDXaWEGmrn2Wz2c6lUemGapuf7sydyUAWjWq12uhBgmWfrOM5bXdefXu4DyWTyU7vd3lvG/9YAjLH4OI4V2KwC5XL5PSKysA+oJpNOp4+LxeLeWr4JK5XKB0rp47DhqKtt2yf5fP7hWgBWqfVFtjf+L4gB/hsFLgARkyUw/Rnd2AAAAABJRU5ErkJggg==",
              index: 1,
              title: "Valuations",
              url: "https://www.notion.so/stonky/Valuations-44f3d6eae8e346448fcc1f8eb815bc24",
              windowId: 0,
              indexPosition: 1000000,
              savedOn: "2021-12-06T02:22:00.127Z",
            },
            {
              pinned: false,
              _id: "61ad73c8fa4c7b40b81fa1d2",
              active: false,
              favIconUrl: "https://www.investopedia.com/favicon.ico",
              index: 2,
              title: "Pre-Money vs. Post-Money: What's the Difference?",
              url: "https://www.investopedia.com/ask/answers/difference-between-premoney-and-postmoney/",
              windowId: 0,
              indexPosition: 1000001,
              savedOn: "2021-12-06T02:22:00.128Z",
            },
          ],
          properties: [],
          workspace: "61ad6e69fa4c7b40b81fa1bd",
          userId: "619a9ae92f709e693cdc9d82",
          urlId: "UscEXtHVs",
          indexPosition: 3,
          createdOn: "2021-12-06T02:21:41.906Z",
          lastEdited: "2021-12-06T02:22:00.128Z",
          __v: 2,
          indexUpdatedOn: "2021-12-06T02:22:23.368Z",
        },
        {
          _id: "61ad73d8fa4c7b40b81fa1e8",
          name: "Copy of Tabs from Dec 5, 2021 7:22 PM",
          urlId: "FCIMjcwFM",
          userId: "619a9ae92f709e693cdc9d82",
          workspace: "61ad6e69fa4c7b40b81fa1bd",
          tabs: [
            {
              pinned: false,
              _id: "61ad73d4fa4c7b40b81fa1df",
              active: false,
              favIconUrl: "https://ssl.gstatic.com/docs/documents/images/kix-favicon7.ico",
              id: 560,
              index: 2,
              title: "$1,250,000 Team Bonus plan - Google Docs",
              url: "https://docs.google.com/document/d/1rUpg1M9PPkeUOBHGQ7uL52uvk5EdxMRAbeWPBXFXtU8/edit",
              windowId: 554,
              indexPosition: 99999,
              savedOn: "2021-12-06T02:22:12.390Z",
            },
            {
              pinned: false,
              _id: "61ad73d4fa4c7b40b81fa1e0",
              active: false,
              favIconUrl:
                "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAzZJREFUWEftl21IU2EUx//Xu003m9t8L6dOl0Wahh8qSwOzjIJIKDIRQTKSyiL6UqBSoBn4rcgwC/SDflArykgK7Q16oTcTNDRfc1lTm+9zWdPtxr3q2p136pJpYc+XC/ee55zfPec855yHAADvCy0eegOVQQC7KUBJv7PXIoA2CrgnIImc7vQgDTFp/AWAIHsZtaK3RUASkYRrdvNFACcX2PiUuUuEW3Zzq73dbu3n6HDQHqBs+Xs/KR9igQPnlhG9EarBMVvUwSaAtAgZsra7z2jg3MNe5L0amDOETQD5cd6IDxWj4ZseXdpxlhHPZSRCvRxR0TiClFtd9gVIKFWjulXHMhKlEKIiSb5EAAZGDdAb2LkrIAnIhKR9PRC70hnF8ctBEgTjfoeJB4yTLONGCscqenC7QWufHLDUqjqtZGDkua1zNmgpaNMpWHoAMYEiyCV8q+7N3enBfDvzQGNVpls7jiqLI2subDUEHs4kPp4K/OPYmm8Mz+vAZysl2iqAQsZHTZoCGp0B5fXDnCCpG6RMEua/5i69cWvEkEt4iCpQoVGj59QxK8DzjlHElXzh3DzbKbiZ6IOtgaL/ALZ5QOpEIiFMDG8xDyc2yZj+XlQzhCaNnslmuvodCHOBu4hEerQb6KKY86QPwz+NKK4dYqriNqUIwZ6OSA6XIMCVj8J3Q2gf0KOsTov+UQMrnNNyoDJZjghfIWfM113+hH0hYpyN4Z4JMqs1qGzSofa4gnM/Vz5NA3h5xB+r3QXIedpnUpIQ5gKlKx87ijqxf60Yh9dLcb9Zh/fqH4xMpL8Q0QEiXH87iBsftKg66Iu2/jGU1v0+PRnRbmjq1WPzVdXMHpgCcDvfYhIsiV+BXaucWQBpd3tMBmjAK3u8WAA0YFK52qSjLzPoHwF4luqPYE8B6NY6tXiTfTe2sBN7Q8Q4ulHKJJuRmpBxIAgmOQveDDJF69EhP9BfDBY66FFuy7VZQkAnGT140krN19fhMSYEvhI+7iT5wInHnoy/jxmRWKZm3Fyd4gu5C7uHGCgKWY97UV7PnhXm1Y7n3SgIUH/FxWRxr2aLfjml47hg13M65hTaza/nvwCegssyiLThjAAAAABJRU5ErkJggg==",
              id: 561,
              index: 3,
              title: "Partizion: Growth Ideas - Airtable",
              url: "https://airtable.com/app1xlaKM2ul6Oyyf/tblapIt6RxKkmSRSH/viwBCoBoG1LBtgl6p?blocks=hide",
              windowId: 554,
              indexPosition: 100000,
              savedOn: "2021-12-06T02:22:12.390Z",
            },
            {
              pinned: false,
              _id: "61ad73d4fa4c7b40b81fa1e2",
              active: false,
              favIconUrl: "https://stonks.com/favicon.ico",
              id: 567,
              index: 5,
              title: "Stonks — YC demo day for everyone",
              url: "https://stonks.com/dashboard/events/events",
              windowId: 554,
              indexPosition: 100002,
              savedOn: "2021-12-06T02:22:12.391Z",
            },
            {
              pinned: false,
              _id: "61ad73d4fa4c7b40b81fa1e3",
              active: false,
              favIconUrl: "https://stonks.com/favicon.ico",
              id: 568,
              index: 6,
              title: "Stonks Events | Stonks",
              url: "https://stonks.com/events",
              windowId: 554,
              indexPosition: 100003,
              savedOn: "2021-12-06T02:22:12.391Z",
            },
            {
              pinned: false,
              _id: "61ad73d4fa4c7b40b81fa1e4",
              active: false,
              favIconUrl: "https://dev.stonks.com/favicon.ico",
              id: 570,
              index: 7,
              title: "Stonks — YC demo day for everyone",
              url: "https://dev.stonks.com/",
              windowId: 554,
              indexPosition: 100004,
              savedOn: "2021-12-06T02:22:12.391Z",
            },
            {
              pinned: false,
              _id: "61ad73d4fa4c7b40b81fa1e5",
              active: false,
              favIconUrl: "https://ssl.gstatic.com/docs/spreadsheets/favicon3.ico",
              id: 572,
              index: 8,
              title: "Startup Signups - Google Sheets",
              url: "https://docs.google.com/spreadsheets/d/1Kfai0lnT96D7B7vzi_2auhZLsL5zqRrg_PY-Wf92Wn8/edit#gid=328970603",
              windowId: 554,
              indexPosition: 100005,
              savedOn: "2021-12-06T02:22:12.391Z",
            },
            {
              pinned: false,
              _id: "61ad73d4fa4c7b40b81fa1e6",
              active: false,
              favIconUrl: "http://principal-api.stonks.com/favicon.ico",
              id: 573,
              index: 9,
              title: "Stonks API",
              url: "http://principal-api.stonks.com/",
              windowId: 554,
              indexPosition: 100006,
              savedOn: "2021-12-06T02:22:12.392Z",
            },
            {
              pinned: false,
              _id: "61ad73d4fa4c7b40b81fa1e7",
              active: false,
              favIconUrl:
                "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAztJREFUWEftV21IU2EUfu6cd875sQ+XIla6uTQtLbQMtQ+M0kSlEIKKCgWpoOhH+CuKCPqTfwqCiKAwsA8orDTDviBD11AhofJzpmnT0G2mzrl5d2+8l5Sp7aYL9c/Or3vf855znvd5D+c9hwKAoJpYNe1gz3NAHgAtWVtCMVJAtVMiujKe2zVE8cEn2XqOgm4Jg85zTXHodAaIMihlpeYaB5xdzuDTsSjgOqWo1HQtA+2ezmckADhP2vCAVQgSy2CyD8Lusi+KJCUth4JWgGEZ9E70ebQVBNCV2wQlreCNOXBwsk702PpQbapFec9D9NtNvG5t4GqcjC3CnvBdCJeoESiWggLF66zOEWhrUrwDYMxthpwOxdfRdsj9Q6GWqECL6BlnLSNf+O9keeLMGgFpdlphcVqRGBK/eAASEY28yGzQIn+UJV+GmBIj4nn8TIAwiRKntMUo0Rzjr4fIOGPD7e57uGm8g2GHZWbvYEEbGI5BactFTLEMXg6+gY2ZmMXGvCuoyryPjLA0txNNzQIwrRBRIpjyCQMUIqsSwHLsPJoJAHKQaXk/1IAD9UeFARh2v4IuWItb3eUoij7EB3BnwN26P/8z/xtVteGvd0wAkOy52/MAJzTH0TlmRNrbvQsDoHyqBckBmVj2XwBsjI1PQst+ow+AjwEfAz4GvGOAPEZNlk8YmPyJH3YTagffoW5Iz1cz90pISnNORBY2yZOwLliDKGkkNiuSMOL85X0has3Rg/QEc4U8LK1jHdgYuh4ujkXbaAcSQuJAQMwV8jLqalK9q4TEmdRPChWtQIxsDbaqUpCu2oI0VSoC/aSzYk247NAPN0JvboTB0oxvtl6YHVY4WAe/z6tS7LGLAFAccwRXky7xW861XOAbFCFZNICy9huCDj+am6ANioaLc6HX1o80leeuhzgqjTu9sCR8llmB7WHbBIMTJcmD7LpCvvWq3fkEYsrvnzYGczP2fTgo/ByTZrIwqkDQ4Q51OrIjsmY5ejHwGg3DBo8gpjgGj75XYowZFwbwz2P82XBGV4Ki6MMgyVfR+5hvx7wRwa7YG4eLtOFWfjBZ8dFsxYdTcmfLOJ6TMbDbfTz/Db6BOK4bvgYdAAAAAElFTkSuQmCC",
              id: 576,
              index: 10,
              title: "Reading List: Reading List - Airtable",
              url: "https://airtable.com/appa18HZnmBAosioj/tblIyg6q9C38sbMxz/viwK9YYbVExbY0LT7?blocks=hide",
              windowId: 554,
              indexPosition: 100007,
              savedOn: "2021-12-06T02:22:12.392Z",
            },
          ],
          indexPosition: 4,
          properties: [],
          createdOn: "2021-12-06T02:22:16.203Z",
          lastEdited: "2021-12-06T02:22:16.203Z",
          __v: 0,
          indexUpdatedOn: "2021-12-06T02:22:23.368Z",
        },
        {
          _id: "61bbbca5c97b9323ee09937c",
          name: "NEW COLLECTIOn",
          tabs: [
            {
              pinned: false,
              _id: "61bbbca5c97b9323ee09937d",
              active: false,
              favIconUrl:
                "data:image/png;base64,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",
              id: 141,
              index: 1,
              title: "(2) Roadmap | API tasks",
              url: "https://www.notion.so/stonky/e0d352e3c21e4e3a9f5ca610166c38aa?v=59460248db5e45e2bcbb665b5dd9252f",
              windowId: 28,
              indexPosition: 99999,
              savedOn: "2021-12-16T22:24:37.556Z",
            },
          ],
          properties: [],
          workspace: "61ad6e69fa4c7b40b81fa1bd",
          userId: "619a9ae92f709e693cdc9d82",
          urlId: "2gQJBS6dd",
          indexPosition: 999999,
          createdOn: "2021-12-16T22:24:37.558Z",
          lastEdited: "2021-12-16T22:24:37.558Z",
          __v: 0,
        },
        {
          _id: "61bbbccec97b9323ee09937e",
          name: "OKAy new name",
          tabs: [
            {
              pinned: false,
              _id: "61bbbccec97b9323ee09937f",
              active: false,
              favIconUrl: "https://www.google.com/a/cpanel/stonks.com/images/favicon.ico",
              id: 255,
              index: 1,
              title: "Inbox (5) - matthew@stonks.com - Stonks Mail",
              url: "https://mail.google.com/mail/u/2/#inbox",
              windowId: 245,
              indexPosition: 99999,
              savedOn: "2021-12-16T22:25:18.854Z",
            },
            {
              pinned: false,
              _id: "61bbbccec97b9323ee099380",
              active: false,
              favIconUrl: "https://github.githubassets.com/favicons/favicon.svg",
              id: 259,
              index: 3,
              title: "GitHub",
              url: "https://github.com/",
              windowId: 245,
              indexPosition: 100000,
              savedOn: "2021-12-16T22:25:18.854Z",
            },
            {
              pinned: false,
              _id: "61bbbccec97b9323ee099381",
              active: false,
              favIconUrl: "https://ssl.gstatic.com/docs/spreadsheets/favicon3.ico",
              id: 264,
              index: 4,
              title: "Partizion Growth Plan - Google Sheets",
              url: "https://docs.google.com/spreadsheets/d/1eSR0qilr9jw3xb3y75_KRKbzKs9NMtEHI6w0rj6prx4/edit?pli=1#gid=0",
              windowId: 245,
              indexPosition: 100001,
              savedOn: "2021-12-16T22:25:18.855Z",
            },
            {
              pinned: false,
              _id: "61bbbccec97b9323ee099382",
              active: false,
              favIconUrl: "https://github.githubassets.com/favicons/favicon.svg",
              id: 258,
              index: 2,
              title: "Stonks",
              url: "https://github.com/stonkscom",
              windowId: 245,
              indexPosition: 100002,
              savedOn: "2021-12-16T22:25:18.856Z",
            },
            {
              pinned: false,
              _id: "61bbbccec97b9323ee099383",
              active: false,
              favIconUrl: "https://cdn.sstatic.net/Sites/stackoverflow/Img/favicon.ico?v=ec617d715196",
              id: 313,
              index: 6,
              title: "git - SSH Key - Still asking for password and passphrase - Stack Overflow",
              url: "https://stackoverflow.com/questions/21095054/ssh-key-still-asking-for-password-and-passphrase",
              windowId: 245,
              indexPosition: 100003,
              savedOn: "2021-12-16T22:25:18.856Z",
            },
            {
              pinned: false,
              _id: "61bbbccec97b9323ee099384",
              active: true,
              favIconUrl: "http://localhost:3001/favicon.ico",
              id: 310,
              index: 5,
              title: "Partizion Dashboard",
              url: "http://localhost:3001/",
              windowId: 245,
              indexPosition: 100004,
              savedOn: "2021-12-16T22:25:18.857Z",
            },
          ],
          properties: [],
          workspace: "61ad6e69fa4c7b40b81fa1bd",
          userId: "619a9ae92f709e693cdc9d82",
          urlId: "EcLNKTYce",
          indexPosition: 999999,
          createdOn: "2021-12-16T22:25:18.857Z",
          lastEdited: "2021-12-16T22:25:18.857Z",
          __v: 0,
        },
      ],
    },
    {
      _id: "61ad6e70fa4c7b40b81fa1be",
      icon: {
        id: "heart_eyes",
        name: "Smiling Face with Heart-Shaped Eyes",
        short_names: ["heart_eyes"],
        colons: ":heart_eyes:",
        emoticons: [],
        unified: "1f60d",
        skin: null,
        native: "😍",
      },
      name: "TEST workspace",
      userId: "619a9ae92f709e693cdc9d82",
      indexPosition: 5,
      createdOn: "2021-12-06T01:59:12.538Z",
      collectionProperties: [
        {
          _id: "61bbc0fdc97b9323ee0993ab",
          type: "singleSelect",
          name: "Status",
          values: [
            {
              _id: "61bbc0fdc97b9323ee0993ac",
              name: "📋 TODO",
              color: "red",
              value: "📋 TODO",
            },
            {
              _id: "61bbc0fdc97b9323ee0993ad",
              name: "🚧 In Progress",
              color: "yellow",
              value: "🚧 In Progress",
            },
            {
              _id: "61bbc0fdc97b9323ee0993ae",
              name: "✔️ Done",
              color: "green",
              value: "✔️ Done",
            },
          ],
          index: 0,
        },
      ],
      __v: 1,
      activeView: "61ad764efa4c7b40b81fa208",
      indexUpdatedOn: "2021-12-06T02:46:59.804Z",
      collections: [
        {
          _id: "61bbc11ac97b9323ee0993af",
          name: "asdfasf",
          tabs: [
            {
              pinned: false,
              _id: "61ad7644fa4c7b40b81fa207",
              active: false,
              favIconUrl: "https://mui.com/static/favicon.ico",
              id: 807,
              index: 2,
              title: "Tab API - MUI",
              url: "https://mui.com/api/tab/",
              windowId: 236,
              indexPosition: 0,
              savedOn: "2021-12-06T02:32:36.614Z",
              indexUpdatedOn: "2021-12-16T22:43:41.854Z",
            },
            {
              pinned: false,
              _id: "61ad6ed2fa4c7b40b81fa1c1",
              active: false,
              favIconUrl:
                "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAzZJREFUWEftl21IU2EUx//Xu003m9t8L6dOl0Wahh8qSwOzjIJIKDIRQTKSyiL6UqBSoBn4rcgwC/SDflArykgK7Q16oTcTNDRfc1lTm+9zWdPtxr3q2p136pJpYc+XC/ee55zfPec855yHAADvCy0eegOVQQC7KUBJv7PXIoA2CrgnIImc7vQgDTFp/AWAIHsZtaK3RUASkYRrdvNFACcX2PiUuUuEW3Zzq73dbu3n6HDQHqBs+Xs/KR9igQPnlhG9EarBMVvUwSaAtAgZsra7z2jg3MNe5L0amDOETQD5cd6IDxWj4ZseXdpxlhHPZSRCvRxR0TiClFtd9gVIKFWjulXHMhKlEKIiSb5EAAZGDdAb2LkrIAnIhKR9PRC70hnF8ctBEgTjfoeJB4yTLONGCscqenC7QWufHLDUqjqtZGDkua1zNmgpaNMpWHoAMYEiyCV8q+7N3enBfDvzQGNVpls7jiqLI2subDUEHs4kPp4K/OPYmm8Mz+vAZysl2iqAQsZHTZoCGp0B5fXDnCCpG6RMEua/5i69cWvEkEt4iCpQoVGj59QxK8DzjlHElXzh3DzbKbiZ6IOtgaL/ALZ5QOpEIiFMDG8xDyc2yZj+XlQzhCaNnslmuvodCHOBu4hEerQb6KKY86QPwz+NKK4dYqriNqUIwZ6OSA6XIMCVj8J3Q2gf0KOsTov+UQMrnNNyoDJZjghfIWfM113+hH0hYpyN4Z4JMqs1qGzSofa4gnM/Vz5NA3h5xB+r3QXIedpnUpIQ5gKlKx87ijqxf60Yh9dLcb9Zh/fqH4xMpL8Q0QEiXH87iBsftKg66Iu2/jGU1v0+PRnRbmjq1WPzVdXMHpgCcDvfYhIsiV+BXaucWQBpd3tMBmjAK3u8WAA0YFK52qSjLzPoHwF4luqPYE8B6NY6tXiTfTe2sBN7Q8Q4ulHKJJuRmpBxIAgmOQveDDJF69EhP9BfDBY66FFuy7VZQkAnGT140krN19fhMSYEvhI+7iT5wInHnoy/jxmRWKZm3Fyd4gu5C7uHGCgKWY97UV7PnhXm1Y7n3SgIUH/FxWRxr2aLfjml47hg13M65hTaza/nvwCegssyiLThjAAAAABJRU5ErkJggg==",
              id: 561,
              index: 3,
              title: "Partizion: Growth Ideas - Airtable",
              url: "https://airtable.com/app1xlaKM2ul6Oyyf/tblapIt6RxKkmSRSH/viwBCoBoG1LBtgl6p?blocks=hide",
              windowId: 554,
              indexPosition: 1,
              savedOn: "2021-12-06T02:00:50.824Z",
              indexUpdatedOn: "2021-12-16T22:46:43.107Z",
            },
            {
              pinned: false,
              _id: "61ad6ed2fa4c7b40b81fa1c2",
              active: false,
              favIconUrl: "https://ssl.gstatic.com/docs/spreadsheets/favicon3.ico",
              id: 562,
              index: 4,
              title: "Partizion Growth Plan - Google Sheets",
              url: "https://docs.google.com/spreadsheets/d/1eSR0qilr9jw3xb3y75_KRKbzKs9NMtEHI6w0rj6prx4/edit?pli=1#gid=0",
              windowId: 554,
              indexPosition: 2,
              savedOn: "2021-12-06T02:00:50.825Z",
              indexUpdatedOn: "2021-12-23T19:59:35.381Z",
            },
          ],
          properties: [
            {
              values: [],
              _id: "61bbc11ac97b9323ee0993b0",
              propertyId: "61bbc0fdc97b9323ee0993ab",
            },
          ],
          workspace: "61ad6e70fa4c7b40b81fa1be",
          userId: "619a9ae92f709e693cdc9d82",
          urlId: "mjyUMzhth",
          indexPosition: 0,
          createdOn: "2021-12-16T22:43:38.215Z",
          lastEdited: "2021-12-23T19:59:40.315Z",
          __v: 6,
          indexUpdatedOn: "2021-12-23T21:20:39.989Z",
        },
        {
          _id: "61c4d521142226040872472a",
          name: "Okay okay okay okaayyy",
          tabs: [
            {
              pinned: false,
              _id: "61c4d521142226040872472b",
              active: false,
              favIconUrl: "https://airtable.com/images/favicon/baymax/favicon-32x32.png",
              id: 320,
              index: 5,
              title: "Sign in - Airtable",
              url: "https://airtable.com/login?continue=%2Fappa18HZnmBAosioj%2FtblIyg6q9C38sbMxz%2FviwK9YYbVExbY0LT7%3Fblocks%3Dhide",
              windowId: 304,
              indexPosition: 99999,
              savedOn: "2021-12-23T19:59:29.603Z",
            },
          ],
          properties: [
            {
              values: ["61bbc0fdc97b9323ee0993ae"],
              _id: "61c4d521142226040872472c",
              propertyId: "61bbc0fdc97b9323ee0993ab",
            },
          ],
          workspace: "61ad6e70fa4c7b40b81fa1be",
          userId: "619a9ae92f709e693cdc9d82",
          urlId: "AvJolGXRP",
          indexPosition: 1,
          createdOn: "2021-12-23T19:59:29.604Z",
          lastEdited: "2021-12-23T19:59:31.162Z",
          __v: 1,
          indexUpdatedOn: "2021-12-23T21:20:39.989Z",
        },
        {
          _id: "61c4dc751422260408724780",
          name: "Copy of hello mate 989",
          urlId: "bU07veDO3",
          userId: "619a9ae92f709e693cdc9d82",
          workspace: "61ad6e70fa4c7b40b81fa1be",
          tabs: [
            {
              pinned: false,
              _id: "61c4dc321422260408724772",
              active: false,
              favIconUrl: "https://airtable.com/images/favicon/baymax/favicon-32x32.png",
              id: 320,
              index: 5,
              title: "Sign in - Airtable",
              url: "https://airtable.com/login?continue=%2Fappa18HZnmBAosioj%2FtblIyg6q9C38sbMxz%2FviwK9YYbVExbY0LT7%3Fblocks%3Dhide",
              windowId: 304,
              indexPosition: 99999,
              savedOn: "2021-12-23T20:29:38.975Z",
            },
            {
              pinned: false,
              _id: "61c4dc321422260408724773",
              active: false,
              favIconUrl: "https://stonks.com/favicon.ico",
              id: 360,
              index: 2,
              title: "Demo Days | Stonks",
              url: "https://stonks.com/dashboard/xoogler/events",
              windowId: 155,
              indexPosition: 100000,
              savedOn: "2021-12-23T20:29:38.976Z",
            },
          ],
          indexPosition: 2,
          properties: [],
          createdOn: "2021-12-23T20:30:45.464Z",
          lastEdited: "2021-12-23T20:30:45.464Z",
          __v: 0,
          indexUpdatedOn: "2021-12-23T21:20:39.989Z",
        },
        {
          _id: "61c4e7ee142226040872479e",
          name: "Copy of Okay okay okay okaayyy",
          urlId: "yY6Nc3k2C",
          userId: "619a9ae92f709e693cdc9d82",
          workspace: "61ad6e70fa4c7b40b81fa1be",
          tabs: [
            {
              pinned: false,
              savedOn: "2021-12-23T19:59:29.603Z",
              _id: "61c4d521142226040872472b",
              active: false,
              favIconUrl: "https://airtable.com/images/favicon/baymax/favicon-32x32.png",
              id: 320,
              index: 5,
              title: "Sign in - Airtable",
              url: "https://airtable.com/login?continue=%2Fappa18HZnmBAosioj%2FtblIyg6q9C38sbMxz%2FviwK9YYbVExbY0LT7%3Fblocks%3Dhide",
              windowId: 304,
              indexPosition: 0,
            },
            {
              pinned: false,
              _id: "61abd8025577261668b49c5e",
              active: true,
              favIconUrl: "http://localhost:3001/favicon.ico",
              id: 141,
              index: 4,
              title: "Partizion Dashboard",
              url: "http://localhost:3001/",
              windowId: 1,
              indexPosition: 1,
              savedOn: "2021-12-04T21:05:06.861Z",
              indexUpdatedOn: "2021-12-24T23:53:27.249Z",
            },
          ],
          indexPosition: 3,
          properties: [
            {
              values: ["61bbc0fdc97b9323ee0993ae"],
              _id: "61c4d521142226040872472c",
              propertyId: "61bbc0fdc97b9323ee0993ab",
            },
          ],
          createdOn: "2021-12-23T21:19:42.154Z",
          lastEdited: "2021-12-24T23:53:27.250Z",
          __v: 1,
          indexUpdatedOn: "2021-12-23T21:20:39.989Z",
        },
        {
          _id: "61c4e4cc1422260408724798",
          name: "New NAME cmonsdfasdf",
          urlId: "2K_dAwGpB",
          userId: "619a9ae92f709e693cdc9d82",
          workspace: "61ad6e70fa4c7b40b81fa1be",
          tabs: [
            {
              pinned: false,
              _id: "61c4dc321422260408724772",
              active: false,
              favIconUrl: "https://airtable.com/images/favicon/baymax/favicon-32x32.png",
              id: 320,
              index: 5,
              title: "Sign in - Airtable",
              url: "https://airtable.com/login?continue=%2Fappa18HZnmBAosioj%2FtblIyg6q9C38sbMxz%2FviwK9YYbVExbY0LT7%3Fblocks%3Dhide",
              windowId: 304,
              indexPosition: 99999,
              savedOn: "2021-12-23T20:29:38.975Z",
            },
            {
              pinned: false,
              _id: "61c4dc321422260408724773",
              active: false,
              favIconUrl: "https://stonks.com/favicon.ico",
              id: 360,
              index: 2,
              title: "Demo Days | Stonks",
              url: "https://stonks.com/dashboard/xoogler/events",
              windowId: 155,
              indexPosition: 100000,
              savedOn: "2021-12-23T20:29:38.976Z",
            },
          ],
          indexPosition: 4,
          properties: [],
          createdOn: "2021-12-23T21:06:20.680Z",
          lastEdited: "2021-12-23T21:06:20.680Z",
          __v: 0,
          indexUpdatedOn: "2021-12-23T21:20:39.989Z",
        },
        {
          _id: "61abd8025577261668b49c5d",
          name: "afdsff",
          tabs: [],
          properties: [],
          workspace: "61ad6e70fa4c7b40b81fa1be",
          userId: "619a9ae92f709e693cdc9d82",
          urlId: "DLAYayW3j",
          indexPosition: 9999999,
          createdOn: "2021-12-04T21:05:06.862Z",
          lastEdited: "2021-12-16T22:41:32.405Z",
          __v: 3,
          indexUpdatedOn: "2021-12-06T02:47:02.202Z",
        },
      ],
    },
    {
      _id: "61ad7758fa4c7b40b81fa20f",
      icon: {
        emoticons: [],
        short_names: [],
      },
      name: "asdfasdff",
      userId: "619a9ae92f709e693cdc9d82",
      indexPosition: 6,
      createdOn: "2021-12-06T02:37:12.638Z",
      collectionProperties: [],
      __v: 0,
      activeView: "61ad775dfa4c7b40b81fa211",
      indexUpdatedOn: "2021-12-06T02:46:59.804Z",
      collections: [
        {
          _id: "61c65d44d65dfc241df63900",
          name: "asdfadf",
          tabs: [
            {
              pinned: false,
              _id: "61c65d44d65dfc241df63901",
              active: false,
              favIconUrl: "https://dashboard.render.com/favicon.ico",
              id: 187,
              index: 1,
              title: "Partizion Web App ・ Static Site ・ Render Dashboard",
              url: "https://dashboard.render.com/static/srv-bq1p2ro8atn6010gom40",
              windowId: 140,
              indexPosition: 99999,
              savedOn: "2021-12-24T23:52:36.340Z",
            },
            {
              pinned: false,
              _id: "61c65d44d65dfc241df63902",
              active: false,
              favIconUrl: "https://github.githubassets.com/favicons/favicon.svg",
              id: 196,
              index: 2,
              title: "mattbf/partizion-dev-server: Node Development server",
              url: "https://github.com/mattbf/partizion-dev-server",
              windowId: 140,
              indexPosition: 100000,
              savedOn: "2021-12-24T23:52:36.340Z",
            },
          ],
          properties: [],
          workspace: "61ad7758fa4c7b40b81fa20f",
          userId: "619a9ae92f709e693cdc9d82",
          urlId: "OMVsh_Ihm",
          indexPosition: 999999,
          createdOn: "2021-12-24T23:52:36.341Z",
          lastEdited: "2021-12-24T23:52:36.341Z",
          __v: 0,
        },
      ],
    },
    {
      _id: "619a9aea2f709e693cdc9d83",
      icon: {
        emoticons: [],
        short_names: ["man-juggling"],
        colons: ":man-juggling:",
        id: "man-juggling",
        name: "Man Juggling",
        native: "🤹‍♂️",
        skin: 1,
        unified: "1f939-200d-2642-fe0f",
      },
      userId: "619a9ae92f709e693cdc9d82",
      name: "Getting Started",
      createdOn: "2021-11-21T19:15:54.157Z",
      collectionProperties: [],
      __v: 0,
      indexPosition: 7,
      indexUpdatedOn: "2021-12-06T02:46:59.804Z",
      activeView: "61ad79e1fa4c7b40b81fa236",
      collections: [
        {
          _id: "619a9aea2f709e693cdc9d87",
          userId: "619a9ae92f709e693cdc9d82",
          urlId: "mkVOikN1F",
          name: "Open multiple tabs with one click!",
          workspace: "619a9aea2f709e693cdc9d83",
          tabs: [
            {
              pinned: false,
              _id: "619a9aea2f709e693cdc9d88",
              id: 1000,
              active: false,
              title: "Google Docs",
              favIconUrl: "https://ssl.gstatic.com/docs/doclist/images/mediatype/icon_1_document_x16.png",
              url: "https://docs.google.com/",
              windowId: 1,
              index: 0,
              indexPosition: 0,
              savedOn: "2021-11-21T19:15:54.253Z",
            },
            {
              pinned: false,
              _id: "619a9aea2f709e693cdc9d89",
              id: 1001,
              active: false,
              title: "Gmail",
              favIconUrl: "https://www.google.com/gmail/about/static/favicon.ico?cache=96bf8f6",
              url: "https://mail.google.com/mail/",
              windowId: 1,
              index: 0,
              indexPosition: 1,
              savedOn: "2021-11-21T19:15:54.253Z",
            },
            {
              pinned: false,
              _id: "619a9aea2f709e693cdc9d8a",
              id: 1001,
              active: false,
              title: "Google Drive",
              favIconUrl: "https://www.google.com/drive/static/images/drive/favicon.ico",
              url: "https://drive.google.com/",
              windowId: 1,
              index: 0,
              indexPosition: 2,
              savedOn: "2021-11-21T19:15:54.253Z",
            },
          ],
          createdOn: "2021-11-21T19:15:54.253Z",
          lastEdited: "2021-12-05T22:43:14.505Z",
          properties: [],
          __v: 1,
          indexPosition: 0,
          indexUpdatedOn: "2021-12-05T22:43:24.441Z",
        },
        {
          _id: "619a9aea2f709e693cdc9d84",
          userId: "619a9ae92f709e693cdc9d82",
          urlId: "mkVOikN1F",
          name: "Getting Started",
          workspace: "619a9aea2f709e693cdc9d83",
          tabs: [
            {
              pinned: false,
              _id: "619a9aea2f709e693cdc9d85",
              id: 1000,
              active: false,
              title: "Partizion Guides",
              favIconUrl: "https://assets.website-files.com/5df81323775eaa30d816fe0a/5dfadfd6d19f9649a654a264_favicon.png",
              url: "https://www.partizion.io/guide/tour",
              windowId: 1,
              index: 0,
              indexPosition: 0,
              savedOn: "2021-11-21T19:15:54.252Z",
            },
            {
              pinned: false,
              _id: "619a9aea2f709e693cdc9d86",
              id: 1000,
              active: false,
              title: "Why we built Partizion",
              favIconUrl: "https://assets.website-files.com/5df81323775eaa30d816fe0a/5dfadfd6d19f9649a654a264_favicon.png",
              url: "https://www.partizion.io/manifesto",
              windowId: 1,
              index: 1,
              indexPosition: 1,
              savedOn: "2021-11-21T19:15:54.252Z",
            },
            {
              pinned: false,
              _id: "61ad4082fa4c7b40b81fa15f",
              active: false,
              favIconUrl:
                "data:image/png;base64,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",
              id: 248,
              index: 2,
              title: "/New TODO",
              url: "https://www.notion.so/matthewbf/New-TODO-6230223ec8dd4ca7aad23c69c6e41a26",
              windowId: 236,
              indexPosition: 2,
              savedOn: "2021-12-05T22:43:14.500Z",
              indexUpdatedOn: "2021-12-05T22:43:22.658Z",
            },
            {
              pinned: false,
              _id: "61ad64fbfa4c7b40b81fa19f",
              active: false,
              favIconUrl: "",
              id: 550,
              index: 1,
              title: "Extensions",
              url: "chrome://extensions/",
              windowId: 236,
              indexPosition: 3,
              savedOn: "2021-12-06T01:18:51.341Z",
              indexUpdatedOn: "2021-12-06T02:48:27.156Z",
            },
          ],
          createdOn: "2021-11-21T19:15:54.252Z",
          lastEdited: "2021-12-06T02:48:27.157Z",
          properties: [],
          __v: 2,
          indexPosition: 1,
          indexUpdatedOn: "2021-12-05T22:43:24.441Z",
        },
        {
          _id: "61ad64fbfa4c7b40b81fa19e",
          name: "Tabs from Dec 5, 2021 6:18 PM",
          tabs: [
            {
              pinned: false,
              _id: "61ad64fbfa4c7b40b81fa1a0",
              active: false,
              favIconUrl:
                "data:image/png;base64,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",
              id: 248,
              index: 2,
              title: "/New TODO",
              url: "https://www.notion.so/matthewbf/New-TODO-6230223ec8dd4ca7aad23c69c6e41a26",
              windowId: 236,
              indexPosition: 100000,
              savedOn: "2021-12-06T01:18:51.342Z",
            },
            {
              pinned: false,
              _id: "61ad64fbfa4c7b40b81fa1a1",
              active: true,
              favIconUrl: "http://localhost:3001/favicon.ico",
              id: 530,
              index: 3,
              title: "New Collection | Partizion",
              url: "http://localhost:3001/new",
              windowId: 236,
              indexPosition: 100001,
              savedOn: "2021-12-06T01:18:51.342Z",
            },
            {
              pinned: false,
              _id: "61ad64fbfa4c7b40b81fa1a2",
              active: false,
              favIconUrl: "https://mui.com/static/favicon.ico",
              id: 639,
              index: 4,
              title: "Button API - MUI",
              url: "https://mui.com/api/button/",
              windowId: 236,
              indexPosition: 100002,
              savedOn: "2021-12-06T01:18:51.343Z",
            },
            {
              pinned: false,
              _id: "61ad64fbfa4c7b40b81fa1a3",
              active: false,
              favIconUrl: "https://developer.mozilla.org/favicon-48x48.97046865.png",
              id: 712,
              index: 5,
              title: "GlobalEventHandlers.onclick - Web APIs | MDN",
              url: "https://developer.mozilla.org/en-US/docs/Web/API/GlobalEventHandlers/onclick",
              windowId: 236,
              indexPosition: 100003,
              savedOn: "2021-12-06T01:18:51.344Z",
            },
          ],
          workspace: "619a9aea2f709e693cdc9d83",
          userId: "619a9ae92f709e693cdc9d82",
          urlId: "kApKXJ5_h",
          indexPosition: 999999,
          createdOn: "2021-12-06T01:18:51.344Z",
          lastEdited: "2021-12-06T01:18:51.344Z",
          properties: [],
          __v: 0,
        },
        {
          _id: "61ad651afa4c7b40b81fa1a4",
          name: "Tabs from Dec 5, 2021 6:19 PM",
          tabs: [],
          workspace: "619a9aea2f709e693cdc9d83",
          userId: "619a9ae92f709e693cdc9d82",
          urlId: "eSWKMugoX",
          indexPosition: 999999,
          createdOn: "2021-12-06T01:19:22.989Z",
          lastEdited: "2021-12-06T01:19:22.989Z",
          properties: [],
          __v: 0,
        },
        {
          _id: "61ad6531fa4c7b40b81fa1a5",
          name: "Tabs from Dec 5, 2021 6:19 PM",
          tabs: [],
          workspace: "619a9aea2f709e693cdc9d83",
          userId: "619a9ae92f709e693cdc9d82",
          urlId: "KUEubdlx8",
          indexPosition: 999999,
          createdOn: "2021-12-06T01:19:45.826Z",
          lastEdited: "2021-12-06T01:19:45.826Z",
          properties: [],
          __v: 0,
        },
        {
          _id: "61ad6600fa4c7b40b81fa1a6",
          name: "Tabs from Dec 5, 2021 6:23 PM",
          tabs: [
            {
              pinned: false,
              _id: "61ad6600fa4c7b40b81fa1a7",
              active: false,
              favIconUrl: "https://mui.com/static/favicon.ico",
              id: 639,
              index: 4,
              title: "Button API - MUI",
              url: "https://mui.com/api/button/",
              windowId: 236,
              indexPosition: 99999,
              savedOn: "2021-12-06T01:23:12.438Z",
            },
            {
              pinned: false,
              _id: "61ad6600fa4c7b40b81fa1a8",
              active: false,
              favIconUrl: "https://developer.mozilla.org/favicon-48x48.97046865.png",
              id: 712,
              index: 5,
              title: "GlobalEventHandlers.onclick - Web APIs | MDN",
              url: "https://developer.mozilla.org/en-US/docs/Web/API/GlobalEventHandlers/onclick",
              windowId: 236,
              indexPosition: 100000,
              savedOn: "2021-12-06T01:23:12.438Z",
            },
          ],
          workspace: "619a9aea2f709e693cdc9d83",
          userId: "619a9ae92f709e693cdc9d82",
          urlId: "5sp6HNvOG",
          indexPosition: 999999,
          createdOn: "2021-12-06T01:23:12.438Z",
          lastEdited: "2021-12-06T01:23:12.438Z",
          properties: [],
          __v: 0,
        },
        {
          _id: "61ad6e5efa4c7b40b81fa1b8",
          name: "Tabs from Dec 5, 2021 6:58 PM",
          tabs: [
            {
              pinned: false,
              _id: "61ad6e5efa4c7b40b81fa1b9",
              active: false,
              favIconUrl: "https://github.githubassets.com/favicons/favicon-dark.svg",
              id: 770,
              index: 1,
              title: "mattbf/partizion-webapp",
              url: "https://github.com/mattbf/partizion-webapp",
              windowId: 236,
              indexPosition: 99999,
              savedOn: "2021-12-06T01:58:54.570Z",
            },
            {
              pinned: false,
              _id: "61ad6e5efa4c7b40b81fa1ba",
              active: false,
              favIconUrl: "https://cdn.sstatic.net/Sites/stackoverflow/Img/favicon.ico?v=ec617d715196",
              id: 773,
              index: 2,
              title: "What is the best (and safest) way to merge a Git branch into master? - Stack Overflow",
              url: "https://stackoverflow.com/questions/5601931/what-is-the-best-and-safest-way-to-merge-a-git-branch-into-master",
              windowId: 236,
              indexPosition: 100000,
              savedOn: "2021-12-06T01:58:54.570Z",
            },
            {
              pinned: false,
              _id: "61ad6e5efa4c7b40b81fa1bb",
              active: true,
              favIconUrl: "http://localhost:3001/favicon.ico",
              id: 761,
              index: 3,
              title: "New Collection | Partizion",
              url: "http://localhost:3001/new",
              windowId: 236,
              indexPosition: 100001,
              savedOn: "2021-12-06T01:58:54.571Z",
            },
          ],
          workspace: "619a9aea2f709e693cdc9d83",
          userId: "619a9ae92f709e693cdc9d82",
          urlId: "OCnhz8e7R",
          indexPosition: 999999,
          createdOn: "2021-12-06T01:58:54.571Z",
          lastEdited: "2021-12-06T01:58:54.571Z",
          properties: [],
          __v: 0,
        },
        {
          _id: "61ad6ed2fa4c7b40b81fa1bf",
          name: "asdfaf",
          tabs: [
            {
              pinned: false,
              _id: "61ad6ed2fa4c7b40b81fa1c0",
              active: true,
              favIconUrl: "http://localhost:3001/favicon.ico",
              id: 794,
              index: 2,
              title: "New Collection | Partizion",
              url: "http://localhost:3001/new",
              windowId: 236,
              indexPosition: 99999,
              savedOn: "2021-12-06T02:00:50.824Z",
            },
            {
              pinned: false,
              _id: "61ad6ed2fa4c7b40b81fa1c3",
              active: false,
              favIconUrl: "https://ssl.gstatic.com/docs/documents/images/kix-favicon7.ico",
              id: 560,
              index: 2,
              title: "$1,250,000 Team Bonus plan - Google Docs",
              url: "https://docs.google.com/document/d/1rUpg1M9PPkeUOBHGQ7uL52uvk5EdxMRAbeWPBXFXtU8/edit",
              windowId: 554,
              indexPosition: 100002,
              savedOn: "2021-12-06T02:00:50.825Z",
            },
            {
              pinned: false,
              _id: "61c4d4db1422260408724727",
              active: false,
              favIconUrl:
                "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAABU9JREFUWEe913tMU1ccB/Dfvb237b29fUhvsS0PBWwYU2TETDZ1xL0SdbqwiTMMUDeySdhENp11YWSGbWY+2Jb52Hwtvjec23SYOUKYJA6jk9KCbaGuWFALAlra0kJf93YpyqLTAULx/H3O7/vJ/Z2cew4CIxgkSSojImRPC6WRSRRFTSEosTCIQC8bRKwuW6fZbGz4ze12d46g1D1TggAIMswiYfKMtKKZcxfmxk6ZpqLlMSCOoAHDudB1/Qq0Wy5rHd3Wxqa66q01NTX6hwWE5g8FkC/Ny9+XkVOwQCiiAUU5wOeT0N5mvnmm4uhOY/2fxx0Oh8loNPpGEzy45oEAgiBiV6uLD81bnJtuu9UDPk8/ICjONOnOn60o371eo2m8MJbQu9feBxCLxQnvqYuPzH52XlrbFQsEAYDLJ0BbW+06+t2uOV12e0O4wu9vgVBIF+W9/cv8l16ZY26xQIBlACdIYPp6wNvVzO4vP6HWN1u2jhuAJMnUNWvW1U9PToUumwMYlgUW4YAAD8CsaQqoOF11fcOmsjkeD7SFCzHYApFUOvFJmUKW+sG69ZtjJ6sQk/EyMAE/IBgOGM6BtOTJYL9hhoKikhzTlbYj4QTIc/KLdoljpi+MpoVIdsZcpLGxGZrrdYCwDGAEAahACKpYGnquXoKPNn5Z2GK5vi1sgBUFhYfLyr7INrV2w4nqOpiVqoJLp3+EVoMeBAQBUloGCI+Am/YboIwSQUuLuXLPoRMLAIANBwIp/XzL8RL12sWhajtO6eCW5W+4Wnsczl2su4pycLdcSqu4GIb1+n0w96knIOO1JVBcukldVVm5OSwAqVSatGf/gVPJaenxvx48AlaLEey9N6CyuvYTq7X9az5FPY5zuVMmSCKWp0RFpS97533AlPHeDUXLlzXU1x8bK2JgE06IjJy96Ll5P3i7O6L9PA74gAn+dV6zpMtm++muALFyomLLC7OfeSuzsAR6vAH7xsKcLJPJ8PtYEP8eRDiOz0yelrxTJBFOMjVfLuno6Nj9gD6jSrn8q4wFi1YtzC+Btvb2zu3Fea8bDIY/Rou45ySkKEoGALTL5WoaoiAao5DvWPJqVv6LeeuhtbWlY+9nq7I1Gs2Z0SCG+xv+X03upKiofVlLc3OeX6EGreZc58Ey9Wq9Xl/+sIjRAkI5VGJc3P6MzOzF1xxeaLhwxoMj7Fqdrn7HwyDGAgC5XC6TSiRV7n5PCuAkCIWCIAbsh1qtZtNIEWMChEJomp4ho+mTXj8TBSgOQpEQIOArbWjQfjwSxJgBoZDo6Oj5IpHoWJ/HR6EYDwQkCVwcyjQXL64b7sQMCyCEiI+Pf4PP5+9193tRDsYDiqIABf83Pq+3aKhbU9gAIYRKpSrBOFip2+MFjMsHgUAABI9zgPH7CzQaTd+DWhJWQCjgscTEb4OArPR4fQMIkiQB5yDHWMa/UqfT2f+LCDtAqVSSEySS7/3+wMseXwBw3m0EwcUqbLabeWazuXvIO+FIdu5wcyIjIyfKZLKTXo83zRdg7yAI4GJoFcsEVmi12vbBGmH/AoOFFQpFEk3TFW6XOyHAwgCCIAgQkryzdntPblNT08C1btwAoeKKmJh0WiL52eVyS9kgAM69jcAxzgWfty9br9e3jCsghIiLi8ukKOqw09nLAwQFnMu7vSd43Dqr9VrWuANCiISEhHcJPrHN2dsLCMoZQFACAbCMr/yRAEKIxMTET3EML3Y4nQMIgs8HHg+veGSA0H6bOjVpe5BFCvr6+4HP5zmcTmcmcueJHHqBPYqBpaSkvMkwjCwY9NcYDKbafwDnJ/eo+ibwjQAAAABJRU5ErkJggg==",
              id: 357,
              index: 1,
              title: "(1) Product",
              url: "https://www.notion.so/stonky/Product-4996d0a953124300802c65f195849473",
              windowId: 155,
              indexPosition: 100003,
              savedOn: "2021-12-23T19:58:19.856Z",
            },
            {
              pinned: false,
              _id: "61c4d4db1422260408724728",
              active: false,
              favIconUrl: "https://stonks.com/favicon.ico",
              id: 360,
              index: 2,
              title: "Demo Days | Stonks",
              url: "https://stonks.com/dashboard/xoogler/events",
              windowId: 155,
              indexPosition: 100004,
              savedOn: "2021-12-23T19:58:19.859Z",
            },
            {
              pinned: false,
              _id: "61c4d4db1422260408724729",
              active: false,
              favIconUrl: "https://ssl.gstatic.com/docs/spreadsheets/favicon3.ico",
              id: 315,
              index: 4,
              title: "Partizion Growth Plan - Google Sheets",
              url: "https://docs.google.com/spreadsheets/d/1eSR0qilr9jw3xb3y75_KRKbzKs9NMtEHI6w0rj6prx4/edit?pli=1#gid=0",
              windowId: 304,
              indexPosition: 100005,
              savedOn: "2021-12-23T19:58:19.859Z",
            },
          ],
          workspace: "619a9aea2f709e693cdc9d83",
          userId: "619a9ae92f709e693cdc9d82",
          urlId: "BlH96bJrT",
          indexPosition: 9999999,
          createdOn: "2021-12-06T02:00:50.825Z",
          lastEdited: "2021-12-23T19:58:19.860Z",
          properties: [],
          __v: 3,
        },
        {
          _id: "61c4e83d14222604087247a4",
          name: "tehee",
          tabs: [
            {
              pinned: false,
              _id: "61c4e83d14222604087247a5",
              active: false,
              favIconUrl: "https://stonks.com/favicon.ico",
              id: 360,
              index: 2,
              title: "Demo Days | Stonks",
              url: "https://stonks.com/dashboard/xoogler/events",
              windowId: 155,
              indexPosition: 99999,
              savedOn: "2021-12-23T21:21:01.318Z",
            },
            {
              pinned: false,
              _id: "61c4e83d14222604087247a6",
              active: false,
              favIconUrl:
                "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAABU9JREFUWEe913tMU1ccB/Dfvb237b29fUhvsS0PBWwYU2TETDZ1xL0SdbqwiTMMUDeySdhENp11YWSGbWY+2Jb52Hwtvjec23SYOUKYJA6jk9KCbaGuWFALAlra0kJf93YpyqLTAULx/H3O7/vJ/Z2cew4CIxgkSSojImRPC6WRSRRFTSEosTCIQC8bRKwuW6fZbGz4ze12d46g1D1TggAIMswiYfKMtKKZcxfmxk6ZpqLlMSCOoAHDudB1/Qq0Wy5rHd3Wxqa66q01NTX6hwWE5g8FkC/Ny9+XkVOwQCiiAUU5wOeT0N5mvnmm4uhOY/2fxx0Oh8loNPpGEzy45oEAgiBiV6uLD81bnJtuu9UDPk8/ICjONOnOn60o371eo2m8MJbQu9feBxCLxQnvqYuPzH52XlrbFQsEAYDLJ0BbW+06+t2uOV12e0O4wu9vgVBIF+W9/cv8l16ZY26xQIBlACdIYPp6wNvVzO4vP6HWN1u2jhuAJMnUNWvW1U9PToUumwMYlgUW4YAAD8CsaQqoOF11fcOmsjkeD7SFCzHYApFUOvFJmUKW+sG69ZtjJ6sQk/EyMAE/IBgOGM6BtOTJYL9hhoKikhzTlbYj4QTIc/KLdoljpi+MpoVIdsZcpLGxGZrrdYCwDGAEAahACKpYGnquXoKPNn5Z2GK5vi1sgBUFhYfLyr7INrV2w4nqOpiVqoJLp3+EVoMeBAQBUloGCI+Am/YboIwSQUuLuXLPoRMLAIANBwIp/XzL8RL12sWhajtO6eCW5W+4Wnsczl2su4pycLdcSqu4GIb1+n0w96knIOO1JVBcukldVVm5OSwAqVSatGf/gVPJaenxvx48AlaLEey9N6CyuvYTq7X9az5FPY5zuVMmSCKWp0RFpS97533AlPHeDUXLlzXU1x8bK2JgE06IjJy96Ll5P3i7O6L9PA74gAn+dV6zpMtm++muALFyomLLC7OfeSuzsAR6vAH7xsKcLJPJ8PtYEP8eRDiOz0yelrxTJBFOMjVfLuno6Nj9gD6jSrn8q4wFi1YtzC+Btvb2zu3Fea8bDIY/Rou45ySkKEoGALTL5WoaoiAao5DvWPJqVv6LeeuhtbWlY+9nq7I1Gs2Z0SCG+xv+X03upKiofVlLc3OeX6EGreZc58Ey9Wq9Xl/+sIjRAkI5VGJc3P6MzOzF1xxeaLhwxoMj7Fqdrn7HwyDGAgC5XC6TSiRV7n5PCuAkCIWCIAbsh1qtZtNIEWMChEJomp4ho+mTXj8TBSgOQpEQIOArbWjQfjwSxJgBoZDo6Oj5IpHoWJ/HR6EYDwQkCVwcyjQXL64b7sQMCyCEiI+Pf4PP5+9193tRDsYDiqIABf83Pq+3aKhbU9gAIYRKpSrBOFip2+MFjMsHgUAABI9zgPH7CzQaTd+DWhJWQCjgscTEb4OArPR4fQMIkiQB5yDHWMa/UqfT2f+LCDtAqVSSEySS7/3+wMseXwBw3m0EwcUqbLabeWazuXvIO+FIdu5wcyIjIyfKZLKTXo83zRdg7yAI4GJoFcsEVmi12vbBGmH/AoOFFQpFEk3TFW6XOyHAwgCCIAgQkryzdntPblNT08C1btwAoeKKmJh0WiL52eVyS9kgAM69jcAxzgWfty9br9e3jCsghIiLi8ukKOqw09nLAwQFnMu7vSd43Dqr9VrWuANCiISEhHcJPrHN2dsLCMoZQFACAbCMr/yRAEKIxMTET3EML3Y4nQMIgs8HHg+veGSA0H6bOjVpe5BFCvr6+4HP5zmcTmcmcueJHHqBPYqBpaSkvMkwjCwY9NcYDKbafwDnJ/eo+ibwjQAAAABJRU5ErkJggg==",
              id: 357,
              index: 1,
              title: "(1) Product",
              url: "https://www.notion.so/stonky/Product-4996d0a953124300802c65f195849473",
              windowId: 155,
              indexPosition: 100000,
              savedOn: "2021-12-23T21:21:01.318Z",
            },
            {
              pinned: false,
              _id: "61c4e83d14222604087247a7",
              active: false,
              favIconUrl: "https://cdn.sstatic.net/Sites/stackoverflow/Img/favicon.ico?v=ec617d715196",
              id: 377,
              index: 4,
              title: "reactjs - Material ui popover how to anchor to another element (different from event target) - Stack Overflow",
              url: "https://stackoverflow.com/questions/56957863/material-ui-popover-how-to-anchor-to-another-element-different-from-event-targe",
              windowId: 155,
              indexPosition: 100001,
              savedOn: "2021-12-23T21:21:01.318Z",
            },
            {
              pinned: false,
              _id: "61c4e83d14222604087247a8",
              active: false,
              favIconUrl: "https://ssl.gstatic.com/docs/documents/images/kix-favicon7.ico",
              id: 314,
              index: 3,
              title: "$1,250,000 Team Bonus plan - Google Docs",
              url: "https://docs.google.com/document/d/1rUpg1M9PPkeUOBHGQ7uL52uvk5EdxMRAbeWPBXFXtU8/edit",
              windowId: 304,
              indexPosition: 100002,
              savedOn: "2021-12-23T21:21:01.318Z",
            },
          ],
          properties: [],
          workspace: "619a9aea2f709e693cdc9d83",
          userId: "619a9ae92f709e693cdc9d82",
          urlId: "HiNhGZt1w",
          indexPosition: 9999999,
          createdOn: "2021-12-23T21:21:01.319Z",
          lastEdited: "2021-12-23T21:21:01.319Z",
          __v: 0,
        },
      ],
    },
  ],
};

export default function SearchDialog(props) {
  const theme = useTheme();
  const [globalState, globalActions] = useGlobal();
  let navigate = useNavigate();

  const params = useParams();
  const open = props.open;
  const handleClickOpen = props.handleOpen;
  const handleClose = props.handleClose;

  const { enqueueSnackbar } = useSnackbar();

  const { browserName, majorVersion, OSName } = DetectClientInfo();
  const [commandOrControl, setCommandOrControl] = useState("⌘");
  useEffect(() => {
    if (OSName === "MacOS") {
      setCommandOrControl("⌘");
    } else {
      setCommandOrControl("Ctrl");
    }
  }, []);

  const { getLinkToCollection } = useEncodeCollectionURL();

  //CLOSE THE DIALOG
  const openSearchEnabled = true;
  useHotkeys(
    "meta+k",
    (KeyboardEvent, HotkeysEvent) => {
      //console.log(HotkeysEvent)
      handleClose();
    },
    {
      openSearchEnabled,
    }
  );

  const { data, isLoadingCollections, isFetchError } = useAllCollections(globalState.isAuth);

  //DATA
  const [recents, setRecents] = useState([]);
  const [results, setResults] = useState([]);
  const [allMatches, setAllMatches] = useState([]);

  const [collections, setCollections] = useState([]);
  const [tabs, setTabs] = useState([]);

  const [recentMatches, setRecentMatches] = useState([]);
  const [collectionMatches, setCollectionMatches] = useState([]);
  const [tabMatches, setTabMatches] = useState([]);

  //GET and format data
  useEffect(() => {
    //const reducer = (prevVal, curVal) => {}
    if (data && data.workspaces) {
      //console.log("update data")
      let collections = data.workspaces
        .reduce((merged, block) => {
          if (block && block.collections && block.collections.length > 0) {
            block.collections.map((collection) => {
              let c = { collection: collection, workspace: block };
              c.workspace = block;
              merged.push(c);
            });
          }
          return merged;
        }, [])
        .sort((a, b) => new Date(b.collection.lastEdited) - new Date(a.collection.lastEdited));

      let tabs = data.workspaces
        .reduce((merged, block) => {
          if (block && block.collections && block.collections.length > 0) {
            block.collections.map((collection) => {
              if (collection && collection.tabs && collection.tabs.length > 0) {
                collection.tabs.map((tab) => {
                  let t = { tab: tab, workspace: block, collection: collection };
                  t.workspace = block;
                  t.collection = collection;
                  merged.push(t);
                });
              }
            });
          }
          return merged;
        }, [])
        .sort((a, b) => new Date(b.tab.savedOn) - new Date(a.tab.savedOn));

      setResults(data.workspaces);
      setCollections(collections);
      setTabs(tabs);
      setCollectionMatches(collections);
      setTabMatches(tabs);
      setAllMatches(recents);
    }

    return () => {
      //cleanup
    };
  }, [data]);

  //GET recents
  useEffect(() => {
    if (globalState.isAuth) {
      axios
        .get("/collections/recents")
        .then((res) => {
          //console.log(res)
          //return res.data
          if (res.data && res.data.recents) {
            //path is correct, move on
            setRecents(res.data.recents);
            setAllMatches(res.data.recents);
            setRecentMatches(res.data.recents);
          } else {
            setRecents([]);
            setRecentMatches([]);
          }
        })
        .catch((err) => {
          console.log("error getting recent collections", err);
          setRecents([]);
        });
    }
  }, [globalState.isAuth]);

  const searchFieldRef = React.useRef();

  function handleCloseDialog(event, reason) {
    if (reason && reason == "escapeKeyDown" && searchInput != null && searchInput != "") {
      event.preventDefault();
      event.stopPropagation();
      setSearchInput("");
      handleChangeQuery();
      if (searchFieldRef && searchFieldRef.current) searchFieldRef.current.focus();
    } else {
      handleClose();
      setSearchInput("");
    }
  }

  const clearSearch = () => {
    setSearchInput("");
    handleChangeQuery();
  };

  //FILTERIGN / SEARCHIGN TABS
  const [searchInput, setSearchInput] = useState("");

  const handleChangeQuery = (e) => {
    const query = e ? e.target.value : "";
    //console.log(results)
    //&& charCode != 38 && charCode != 40
    const trimmed = query.trim();
    //console.log({trimmed})

    if (trimmed && trimmed != null && trimmed != "" && trimmed.length && trimmed.length > 0) {
      const collectionKeys = ["collection.name", "workspace.name"]; //['tabs.*.title', 'tabs.*.url']
      const tabKeys = ["tab.title", "tab.url"];

      const splitQuery = query.split(" ").filter(Boolean);
      //console.log({splitQuery})

      const tempRecentMatches = filterSelected.indexOf(0) > -1 ? matchSorter(recents, trimmed, { keys: collectionKeys }) : [];
      const tempCollectionMatches =
        filterSelected.indexOf(1) > -1 || (filterSelected.length == 1 && filterSelected.indexOf(0) > -1)
          ? matchSorter(collections, trimmed, { keys: collectionKeys })
          : [];
      const tempTabMatches =
        filterSelected.indexOf(2) > -1 || (filterSelected.length == 1 && filterSelected.indexOf(0) > -1) ? matchSorter(tabs, trimmed, { keys: tabKeys }) : [];

      //console.log(tempCollectionMatches)

      //RECENTS
      function filterRecents() {
        if (
          (tempRecentMatches && tempRecentMatches.length <= 0 && splitQuery && splitQuery.length > 1 && filterSelected.indexOf(1) > -1) ||
          (splitQuery && splitQuery.length > 1 && splitQuery.every((t) => t != null && t != "" && t.length > 0) && filterSelected.indexOf(1) > -1)
        ) {
          const multiWordMatches = splitQuery.reduceRight((results, term) => matchSorter(results, term, { keys: collectionKeys }), recents);
          setRecentMatches(multiWordMatches);
          return multiWordMatches.concat(filterCollections());
        } else {
          setRecentMatches(tempRecentMatches);
          return tempRecentMatches.concat(filterCollections());
        }
      }

      //COLLECTIONS
      function filterCollections() {
        if (
          (tempCollectionMatches && tempCollectionMatches.length <= 0 && splitQuery && splitQuery.length > 1 && filterSelected.indexOf(1) > -1) ||
          (splitQuery && splitQuery.length > 1 && splitQuery.every((t) => t != null && t != "" && t.length > 0) && filterSelected.indexOf(1) > -1)
        ) {
          //console.log('try multi word collection match')
          const multiWordMatches = splitQuery.reduceRight((results, term) => {
            // console.log(term, results)
            // console.log(matchSorter(results, term, {keys: collectionKeys}))
            return matchSorter(results, term, { keys: collectionKeys });
          }, collections);
          setCollectionMatches(multiWordMatches);
          return multiWordMatches.concat(filterTabs());
        } else {
          setCollectionMatches(tempCollectionMatches);
          return tempCollectionMatches.concat(filterTabs());
        }
      }

      //TABS
      function filterTabs() {
        // if(tempTabMatches && tempTabMatches.length <= 0 && splitQuery && splitQuery.length > 1 && filterSelected.indexOf(2) > -1 || splitQuery && splitQuery.length > 1 && splitQuery.every(t => t != null && t != "" && t.length > 0) && filterSelected.indexOf(2) > -1){
        //     console.log("use multi word match on tabs")
        //     const multiWordMatches = splitQuery.reduceRight(
        //         (tabs, term) => matchSorter(tabs, term, {keys: tabKeys}),
        //         tabs,
        //     )

        //     // const filteredTabCollections = multiWordMatches.map((w, index) => {
        //     //   w = {...w, tabs: matchSorter(w.tabs, splitQuery[1], {keys: ['title', 'url']}) }
        //     //   return w
        //     // })
        //     setTabMatches(multiWordMatches)
        //     return multiWordMatches
        // } else {
        //   setTabMatches(tempTabMatches)
        //   return tempTabMatches
        // }
        setTabMatches(tempTabMatches);
        return tempTabMatches;
      }

      //AGGREGATE EVERYTHING
      if (filterSelected.indexOf(0) > -1 && filterSelected.length == 1 && searchInput == "") {
        setAllMatches(filterRecents());
      } else {
        setAllMatches(filterCollections());
      }
    } else if (filterSelected.indexOf(1) > -1 || filterSelected.indexOf(2) > -1) {
      setCollectionMatches(collections);
      setTabMatches(tabs);
      setRecentMatches(recents);

      if (filterSelected.indexOf(1) > -1) {
        if (filterSelected.indexOf(2) > -1) {
          setAllMatches(collections.concat(tabs));
        } else {
          setAllMatches(collections);
        }
      } else {
        setAllMatches(tabs);
      }
    } else {
      //setSearchMatches(exampleWindows)
      setCollectionMatches(collections);
      setTabMatches(tabs);
      setRecentMatches(recents);
      setAllMatches(recents);
    }

    setFocusSelected(0);
  };

  //WINDOWS

  const handleInputKeyPress = (event) => {
    var charCode = event.which || event.charCode || event.keyCode;
    //console.log(charCode)
    console.log({ charCode, event });

    if ((charCode == 75 && event.metaKey) || (charCode == 75 && event.ctrlKey)) {
      handleClose();
    } else if (charCode == 13 && focusSelected != null) {
      //ENTER
      const meta = event.metaKey || event.ctrlKey;
      const shiftKey = event.shiftKey;
      const result = allMatches[focusSelected];
      if (result) {
        if (result && result.tab) {
          handleOpenTab(result.tab, meta, shiftKey);
        } else if (result.collection && result.workspace) {
          handleOpenCollection(result.collection, result.workspace, meta, event.shiftKey);
        }
      }
    } else if ((charCode == 67 && event.metaKey) || (charCode == 67 && event.ctrlKey)) {
      //COMMAND COPY
      event.preventDefault();
      event.stopPropagation();
      const result = allMatches[focusSelected];
      if (result) {
        if (result && result.tab) {
          handleCopyToClipBoard(result.tab.url);
        } else {
          const LinkToCollection = getLinkToCollection(result.collection?._collectionId, result.collection?.name);
          // handleCopyToClipBoard(`https://app.partizion.io/${paramCase(result.workspace._id)}/${result.collection.urlId}`);
          handleCopyToClipBoard(`https://app.partizion.io${LinkToCollection}`);
        }
      }
    } else if ((charCode == 49 && event.metaKey) || (charCode == 49 && event.ctrlKey)) {
      //COMMAND 1
      event.preventDefault();
      event.stopPropagation();
      handleSelectFilter(event, 1);
    } else if ((charCode == 50 && event.metaKey) || (charCode == 50 && event.ctrlKey)) {
      //COMMAND 2
      event.preventDefault();
      event.stopPropagation();
      handleSelectFilter(event, 2);
    } else if (charCode == 40) {
      event.stopPropagation();
      event.preventDefault();
      //console.log("down")
      handleIncrementSelected("down"); //removed, seemed to be duplicating
    } else if (charCode == 38) {
      event.stopPropagation();
      event.preventDefault();
      //console.log("up")
      handleIncrementSelected("up"); //removed, seemed to be duplicating
    } else if (charCode == 9) {
      event.stopPropagation();
      event.preventDefault();
      if (searchFieldRef && searchFieldRef.current) searchFieldRef.current.focus();
    }
  };

  //FILTERS
  const [filterSelected, setFilterSelected] = useState([0]);
  const handleSelectFilter = (event, value) => {
    //console.log(event.target.value)
    setFilterSelected((curArr) => {
      // console.log(curArr)
      // console.log(event.shiftKey)
      if (event && event.shiftKey && value != 0) {
        let noZero = curArr.filter((v) => v != 0);
        return [...noZero, value];
      } else {
        return [value];
      }
    });
    if (searchFieldRef && searchFieldRef.current) searchFieldRef.current.focus();
    // setFilterSelected(value)
  };
  const resultCount = allMatches && allMatches.length ? allMatches.length : 0; //collectionMatches && recentMatches && tabMatches ? collectionMatches.length + recentMatches.length + tabMatches.length : 0

  useHotkeys(
    "meta+1, meta+2",
    (KeyboardEvent, HotkeysEvent) => {
      //console.log(KeyboardEvent, HotkeysEvent)
      KeyboardEvent.preventDefault();
      KeyboardEvent.stopPropagation();
      const keyValue = HotkeysEvent.shortcut == "meta+1" || HotkeysEvent.shortcut == "meta+1" ? 1 : 2;
      handleSelectFilter(KeyboardEvent, keyValue);
    },
    {
      openSearchEnabled,
    }
  );

  //STYLES
  const outerPadding = 18;

  //SELECTED RESULT
  const scrollbarRef = React.useRef();
  const focusedRef = React.useRef();
  const scrollBarsDivRef = React.useRef();
  var nodes = document.getElementsByClassName("selectableResultListItem");
  //console.log(nodes)

  const [focusSelected, setFocusSelected] = useState(0);
  const handleMouseSelected = (index) => {
    if (index != null && index != undefined) {
      //console.log(index, allMatches)
      setFocusSelected(index);
    }
  };
  const handleIncrementSelected = (hotkey) => {
    let resultsLength;
    setAllMatches((curMatches) => {
      resultsLength = curMatches.length;
      return curMatches;
    });
    //console.log(hotkey)
    switch (hotkey) {
      case "down":
        setFocusSelected((prevIndex) => {
          //console.log(prevIndex)
          if (prevIndex == null || prevIndex > resultsLength || prevIndex < 0) {
            //console.log("select top item DOWN")
            return 0; //({index: topInView, handler: "keys"})
          } else if (prevIndex === resultsLength - 1) {
            //select top index
            //console.log("Select top")
            scrollbarRef.current.refs.scrollbars.scrollToTop();
            return 0; //({index: 0, handler: "keys"})
          } else {
            scrollListItem(nodes[prevIndex + 1]);
            let increment = prevIndex + 1;
            return increment; //({index: increment, handler: "keys"})
          }
        });
        break;
      case "up":
        setFocusSelected((prevIndex) => {
          //console.log(prevIndex)
          //console.log(prevObj)
          //console.log({topInView})
          if (prevIndex == null) {
            //console.log("select top item UP")
            return 0; //({index: topInView, handler: "keys"})
          } else if (prevIndex === 0) {
            //select top index
            //console.log("Select bottom")
            scrollbarRef.current.refs.scrollbars.scrollToBottom();
            let lastItemIndex = resultsLength - 1;
            //console.log({lastItemIndex})
            return lastItemIndex; //({index: lastItemIndex, handler: "keys"})
          } else {
            scrollListItem(nodes[prevIndex - 1]);
            let decrement = prevIndex - 1;
            return decrement; //({index: decrement, handler: "keys"})
          }
        });
        break;
    }
  };
  function scrollListItem(el, custom) {
    //console.log(el)
    var s = [].indexOf.call(nodes, el);
    if (s === -1) return;

    var elHeight = el ? el.getBoundingClientRect().height : 0;
    //var topDivHeight = dynamicTopDiv.current.getBoundingClientRect().height
    // var scrollTop = scrollBarsDivRef.current.scrollTop
    // var viewport = scrollTop + scrollBarsDivRef.current.getBoundingClientRect().height
    // var totalScrollHeight = scrollBarsDivRef.current.scrollHeight
    // var elOffset = custom && custom == "reset" ? 0 : custom && custom == "bottom" ? totalScrollHeight : elHeight * s

    // console.log(scrollbarRef)

    // console.log(scrollbarRef.current.refs.scrollbars.getScrollTop())
    // console.log(scrollbarRef.current.refs.scrollbars.getScrollTop())

    var scrollTop = scrollbarRef.current.refs.scrollbars.getScrollTop();
    var viewport = scrollTop + scrollbarRef.current.refs.scrollbars.getClientHeight();
    var totalScrollHeight = scrollbarRef.current.refs.scrollbars.getScrollHeight();
    var elOffset = custom && custom == "reset" ? 0 : custom && custom == "bottom" ? totalScrollHeight : el ? el.offsetTop - 15 : elHeight * s;

    var elOffsetV2 = el.offsetTop;
    //nodes.slice(0, s).reduce((prev, cur) => prev.)

    //console.log({s, elOffset, scrollTop, viewport})
    //console.log(recentMatches.length, {elOffset})

    //console.log({elHeight, elOffset, elOffsetV2, scrollTop, viewport})
    if (elOffset < scrollTop || elOffset + elHeight >= viewport) scrollbarRef.current.refs.scrollbars.scrollTop(elOffset);
  }
  useHotkeys(
    "up, down",
    (KeyboardEvent, HotkeysEvent) => {
      //console.log(KeyboardEvent, HotkeysEvent)
      // KeyboardEvent.preventDefault()
      // KeyboardEvent.stopPropagation()
      //console.log("useHotkeys: " + HotkeysEvent.shortcut)
      handleIncrementSelected(HotkeysEvent.shortcut);
    },
    {
      openSearchEnabled,
    }
  );

  useHotkeys(
    "enter",
    (KeyboardEvent, HotkeysEvent) => {
      //console.log(KeyboardEvent, HotkeysEvent)
      // KeyboardEvent.preventDefault()
      // KeyboardEvent.stopPropagation()
      const meta = KeyboardEvent.metaKey || KeyboardEvent.ctrlKey;
      const shiftKey = KeyboardEvent.shiftKey;
      const result = allMatches[focusSelected];
      //console.log({result})
      if (focusSelected && result) {
        if (result.tab) {
          handleOpenTab(result.tab, meta, shiftKey);
        } else {
          handleOpenCollection(result.collection, result.workspace, meta, KeyboardEvent.shiftKey);
        }
      }
    },
    {
      openSearchEnabled,
    }
  );
  useHotkeys(
    "meta+c",
    (KeyboardEvent, HotkeysEvent) => {
      //console.log(KeyboardEvent, HotkeysEvent)
      KeyboardEvent.preventDefault();
      KeyboardEvent.stopPropagation();
      const result = allMatches[focusSelected];
      if (result) {
        if (result && result.tab) {
          handleCopyToClipBoard(result.tab.url);
        } else {
          const LinkToCollection = getLinkToCollection(result.collection?._collectionId, result.collection?.name);
          // handleCopyToClipBoard(`https://app.partizion.io/${paramCase(result.workspace._id)}/${result.collection.urlId}`);
          handleCopyToClipBoard(`https://app.partizion.io${LinkToCollection}`);
        }
      }
    },
    {
      openSearchEnabled,
    }
  );

  //ACTIONS

  const handleOpenCollection = (collection, workspace, newtab, newWindow) => {
    // globalActions.saveActiveWorkspaceIndex(index)
    // localStorage.setItem("activeWorkspaceIndex", index)
    // const activeView =  workspace && workspace.views ? workspace.activeView ? workspace.views.find(v => v._id === workspace.activeView) :  workspace.views[0] : null
    // globalActions.setActiveView(activeView)
    //console.log(newtab)
    let LinkToCollection = getLinkToCollection(collection?._collectionId, collection?.name);

    if (newtab) {
      if (globalState.extensionConnection.isConnected) {
        globalState.extensionConnection.port.postMessage({
          type: "openTab",
          tab: { url: `https://app.partizion.io${LinkToCollection}` },
          metaKey: true,
        });
        //handleCloseDialog()
      } else {
        window.open(`https://app.partizion.io${LinkToCollection}`, "_newtab");
        handleCloseDialog();
      }
    } else if (newWindow && globalState.extensionConnection.isConnected) {
      // const workspace = globalState.workspaces.find((w) => w._id === collection.workspace);
      globalState.extensionConnection.port.postMessage({
        type: "openCollection",
        shiftKey: true,
        newtabs: collection.tabs,
        openType: "add",
        windowId: globalState.extensionConnection.windowId,
        tabId: globalState.extensionConnection.tabId,
        collection: collection,
        workspace: workspace,
      });
      handleCloseDialog();
    } else {
      globalActions.saveActiveWorkspace(workspace);
      navigate(LinkToCollection);

      handleCloseDialog();
    }
  };
  const handleOpenTab = (tab, metaKey, shiftKey) => {
    //globalActions.saveActiveWorkspaceIndex(index)
    //localStorage.setItem("activeWorkspaceIndex", index)

    if (globalState.extensionConnection.isConnected) {
      globalState.extensionConnection.port.postMessage({ type: "openTab", tab: tab, shiftKey: shiftKey, metaKey: metaKey });
      if (!metaKey) handleCloseDialog();
    } else {
      if (metaKey) {
        window.open(`${tab.url}`, "_newtab");
        if (!metaKey) handleCloseDialog();
      } else {
        window.open(`${tab.url}`);
        handleCloseDialog();
      }
    }
  };
  const copyToClipBoard = async (copyMe) => {
    try {
      await navigator.clipboard.writeText(copyMe);
      return true;
      //setCopySuccess('Copied!');
    } catch (err) {
      console.log(err);
      return false;
      //setCopySuccess('Failed to copy!');
    }
  };
  const handleCopyToClipBoard = (content) => {
    copyToClipBoard(content)
      .then(() => {
        var message = "🔗  Copied URL to clipboard";
        enqueueSnackbar(message, {
          content: (key, message) => <PlainSnackBar id={key} message={message} />,
        });
      })
      .catch((err) => {
        console.log(err);
        console.log("error copying url :(");
      });
  };

  //RESTTING SEARCH
  useEffect(() => {
    // if(searchInput && searchInput != ''){
    //     handleChangeQuery({target: {value: searchInput}})
    // }
    handleChangeQuery({ target: { value: searchInput } });
    if (scrollbarRef && scrollbarRef.current && scrollbarRef.current.refs && scrollbarRef.current.refs.scrollbars)
      scrollbarRef.current.refs.scrollbars.scrollToTop();
    setFocusSelected(0);

    return () => {
      //cleanup
      setFocusSelected(0);
    };
  }, [filterSelected]);

  //scroll to top on query / results change
  useEffect(() => {
    //console.log("RESET FOCUS")
    if (scrollbarRef && scrollbarRef.current && scrollbarRef.current.refs && scrollbarRef.current.refs.scrollbars)
      scrollbarRef.current.refs.scrollbars.scrollToTop();
    setFocusSelected(0);

    return () => {
      setFocusSelected(0);
    };
  }, [allMatches]);

  return (
    <div>
      <Dialog aria-describedby="alert-dialog-description" aria-labelledby="alert-dialog-title" onClose={handleCloseDialog} open={open}>
        <div style={{ width: "100%", padding: outerPadding, paddingTop: 12, paddingBottom: 6, backgroundColor: theme.palette.background.default }}>
          {isFetchError ? <DialogContentText color="secondary">We're having trouble searching right now... please try again later</DialogContentText> : null}
          <SearchBar
            clearSearch={clearSearch}
            filterSelected={filterSelected}
            handlePreventHotKey={handleInputKeyPress}
            // handlePreventHotKey={(e) => handleInputKeyPress(e)}
            onChange={handleChangeQuery}
            searchFieldRef={searchFieldRef}
            searchInput={searchInput}
            setSearchInput={setSearchInput}
          />

          <div style={{ paddingTop: 12, display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between" }}>
            <div style={{ paddingRight: "10px", display: "flex", flexDirection: "row", alignItems: "center", minWidth: 150, flexWrap: "nowrap", opacity: 0.8 }}>
              {searchInput != "" && allMatches && allMatches.length > 0 && (
                <>
                  <CallMissedOutgoingRoundedIcon
                    style={{
                      fontSize: 20,
                      color: theme.palette.text.primary,
                      opacity: 0.5,
                      transform: "rotate(45deg)",
                      position: "relative",
                      top: -2,
                      marginRight: 5,
                    }}
                  />
                  <Typography style={{ color: theme.palette.text.primary, opacity: 0.5 }} variant="caption">
                    {allMatches.length}
                    {allMatches.length == 1 ? " result" : " results"}
                  </Typography>
                </>
              )}
            </div>
            <div style={{ color: theme.palette.text.tertiary, display: "flex", alignItems: "center" }}>
              {filterSelected && filterSelected[0] != 0 && (
                <Button
                  color="inherit"
                  onClick={(e) => {
                    handleSelectFilter(e, 0);
                  }}
                  size="small"
                  style={{ color: "inherit", padding: 4, paddingRight: 6, paddingLeft: 6, paddingBottom: 3, fontSize: 12, minWidth: 10 }}
                  value={1}
                >
                  Clear
                </Button>
              )}
              <div style={{ borderBottom: "2px solid", borderColor: filterSelected.indexOf(1) > -1 ? theme.palette.text.secondary : "rgba(255, 255, 255, 0)" }}>
                <Button
                  color="inherit"
                  component="button"
                  onClick={(e) => {
                    handleSelectFilter(e, 1);
                  }}
                  size="small"
                  style={{
                    color: filterSelected.indexOf(1) > -1 ? theme.palette.text.secondary : "inherit",
                    padding: 4,
                    paddingRight: 6,
                    paddingLeft: 6,
                    paddingBottom: 3,
                    fontSize: 12,
                  }}
                  value={1}
                >
                  Collections
                  <HotkeyChip keys={[`${commandOrControl}`, "1"]} />
                </Button>
              </div>
              <div style={{ borderBottom: "2px solid", borderColor: filterSelected.indexOf(2) > -1 ? theme.palette.text.secondary : "rgba(255, 255, 255, 0)" }}>
                <Button
                  color="inherit"
                  component="button"
                  onClick={(e) => {
                    handleSelectFilter(e, 2);
                  }}
                  size="small"
                  style={{
                    color: filterSelected.indexOf(2) > -1 ? theme.palette.text.secondary : "inherit",
                    padding: 4,
                    paddingRight: 6,
                    paddingLeft: 6,
                    paddingBottom: 3,
                    fontSize: 12,
                  }}
                  value={2}
                >
                  Tabs
                  <HotkeyChip keys={[`${commandOrControl}`, "2"]} />
                </Button>
              </div>
            </div>
          </div>
        </div>
        <Divider />
        <div style={{ minWidth: "600px" }}>
          <div
            style={{
              width: "100%",
              height: 450,
              backgroundColor: theme.palette.background.default, //HERE
            }}
          >
            <ShadowScrollbars autoHide={false} ref={scrollbarRef} style={{ height: "100%" }}>
              <div
                ref={scrollBarsDivRef}
                style={{
                  paddingTop: 24,
                  paddingBottom: 24,
                }}
              >
                {isLoadingCollections ? ( //|| recentMatches && recentMatches.length == 0
                  <div style={{ width: "100%", minHeight: 200, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                    <CircularProgress size={24} style={{ color: theme.palette.text.tertiary }} />
                  </div>
                ) : (
                  <>
                    {filterSelected.indexOf(0) > -1 && filterSelected.length == 1 && searchInput == "" ? (
                      <ResultsWrapper
                        allMatches={allMatches}
                        focusSelected={focusSelected}
                        focusedRef={focusedRef}
                        handleCopyToClipBoard={handleCopyToClipBoard}
                        handleMouseSelected={handleMouseSelected}
                        openCollection={handleOpenCollection}
                        outerPadding={outerPadding}
                        results={recentMatches}
                        title="recent collections"
                        type="collection"
                      />
                    ) : null}
                    {(resultCount > 0 && collectionMatches && collectionMatches.length > 0 && searchInput != "" && filterSelected.indexOf(1) > -1) ||
                    (resultCount > 0 && collectionMatches && collectionMatches.length > 0 && searchInput != "" && filterSelected.indexOf(0) > -1) ||
                    (resultCount > 0 && filterSelected.indexOf(1) > -1 && filterSelected.length == 1) ? (
                      <ResultsWrapper
                        allMatches={allMatches}
                        focusSelected={focusSelected}
                        focusedRef={focusedRef}
                        handleCopyToClipBoard={handleCopyToClipBoard}
                        handleMouseSelected={handleMouseSelected}
                        openCollection={handleOpenCollection}
                        outerPadding={outerPadding}
                        results={collectionMatches}
                        title="collections"
                        type="collection"
                      />
                    ) : null}

                    {(resultCount > 0 && tabMatches && tabMatches.length > 0 && searchInput != "" && filterSelected.indexOf(2) > -1) ||
                    (resultCount > 0 && tabMatches && tabMatches.length > 0 && searchInput != "" && filterSelected.indexOf(0) > -1) ||
                    (resultCount > 0 && filterSelected.indexOf(2) > -1 && filterSelected.length == 1) ? (
                      <ResultsWrapper
                        allMatches={allMatches}
                        focusSelected={focusSelected}
                        focusedRef={focusedRef}
                        handleCopyToClipBoard={handleCopyToClipBoard}
                        handleMouseSelected={handleMouseSelected}
                        handleOpenTab={handleOpenTab}
                        openCollection={handleOpenCollection}
                        outerPadding={outerPadding}
                        results={tabMatches}
                        title="tabs"
                        type="tab"
                      />
                    ) : null}
                    {results &&
                    results.length > 0 &&
                    collectionMatches &&
                    collectionMatches.length < 1 &&
                    tabMatches &&
                    tabMatches.length < 1 &&
                    searchInput &&
                    searchInput.length > 0 ? (
                      <div style={{ width: "100%", minHeight: 100, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                        <Typography align="center" noWrap style={{ color: theme.palette.text.secondary, marginBottom: 10 }} variant="body1">
                          🔍 &nbsp; No Results
                        </Typography>
                        <Typography align="center" noWrap style={{ color: theme.palette.text.secondary }} variant="body2">
                          Try a different search query
                        </Typography>
                      </div>
                    ) : results &&
                      results.length > 0 &&
                      collectionMatches &&
                      collectionMatches.length < 1 &&
                      filterSelected.indexOf(1) > -1 &&
                      filterSelected.length == 1 ? (
                      <div style={{ width: "100%", minHeight: 100, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                        <Typography align="center" noWrap style={{ color: theme.palette.text.secondary, marginBottom: 10 }} variant="body1">
                          🔍 &nbsp; No Results
                        </Typography>
                        <Typography align="center" noWrap style={{ color: theme.palette.text.secondary }} variant="body2">
                          Try a different search query
                        </Typography>
                      </div>
                    ) : results && results.length > 0 && tabMatches && tabMatches.length < 1 && filterSelected.indexOf(2) > -1 && filterSelected.length == 1 ? (
                      <div style={{ width: "100%", minHeight: 100, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                        <Typography align="center" noWrap style={{ color: theme.palette.text.secondary, marginBottom: 10 }} variant="body1">
                          🔍 &nbsp; No Results
                        </Typography>
                        <Typography align="center" noWrap style={{ color: theme.palette.text.secondary }} variant="body2">
                          Try a different search query
                        </Typography>
                      </div>
                    ) : null}
                  </>
                )}
              </div>
            </ShadowScrollbars>
          </div>
        </div>

        <Divider />
        <DialogActions
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: globalState.extensionConnection && globalState.extensionConnection.isConnected ? "space-between" : "flex-end",
            paddingLeft: outerPadding,
            paddingRight: outerPadding,
            backgroundColor: theme.palette.background.default, //HERE
          }}
        >
          <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "flex-start", width: "100%" }}>
            <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between" }}>
              <HotkeyChip
                fixed
                keys={[
                  <ArrowDownwardRoundedIcon style={{ fontSize: 14, color: theme.palette.text.secondary }} />,
                  <ArrowUpwardRoundedIcon style={{ fontSize: 14, color: theme.palette.text.secondary }} />,
                ]}
              />
              <Typography
                noWrap
                style={{ color: theme.palette.text.tertiary, display: "flex", alignItems: "center", marginRight: 12, marginLeft: 2 }}
                variant="caption"
              >
                Select results
              </Typography>
            </div>

            <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between" }}>
              {allMatches && allMatches[focusSelected] && allMatches[focusSelected].tab ? (
                <>
                  <HotkeyChip keys={[<KeyboardReturnIcon style={{ fontSize: 14, color: theme.palette.text.secondary }} />]} />
                  <Typography
                    noWrap
                    style={{ color: theme.palette.text.tertiary, display: "flex", alignItems: "center", marginRight: 12, marginLeft: 2 }}
                    variant="caption"
                  >
                    Open
                  </Typography>
                </>
              ) : (
                <>
                  <HotkeyChip keys={[<KeyboardReturnIcon style={{ fontSize: 14, color: theme.palette.text.secondary }} />]} />
                  <Typography
                    noWrap
                    style={{ color: theme.palette.text.tertiary, display: "flex", alignItems: "center", marginRight: 12, marginLeft: 2 }}
                    variant="caption"
                  >
                    Open
                  </Typography>
                </>
              )}
            </div>
            <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between" }}>
              {allMatches && allMatches[focusSelected] && allMatches[focusSelected].tab ? (
                <>
                  <HotkeyChip keys={[`${commandOrControl}`, <KeyboardReturnIcon style={{ fontSize: 14, color: theme.palette.text.secondary }} />]} />
                  <Typography
                    noWrap
                    style={{ color: theme.palette.text.tertiary, display: "flex", alignItems: "center", marginRight: 12, marginLeft: 2 }}
                    variant="caption"
                  >
                    Open in background
                  </Typography>
                </>
              ) : (
                <>
                  <HotkeyChip keys={[`${commandOrControl}`, <KeyboardReturnIcon style={{ fontSize: 14, color: theme.palette.text.secondary }} />]} />
                  <Typography
                    noWrap
                    style={{ color: theme.palette.text.tertiary, display: "flex", alignItems: "center", marginRight: 12, marginLeft: 2 }}
                    variant="caption"
                  >
                    Open in new tab
                  </Typography>
                </>
              )}
            </div>
            {allMatches && allMatches[focusSelected] && allMatches[focusSelected].tab ? (
              <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between" }}>
                <HotkeyChip keys={["SHIFT", <KeyboardReturnIcon style={{ fontSize: 14, color: theme.palette.text.secondary }} />]} />
                <Typography
                  noWrap
                  style={{ color: theme.palette.text.tertiary, display: "flex", alignItems: "center", marginRight: 12, marginLeft: 2 }}
                  variant="caption"
                >
                  Open in new window
                </Typography>
              </div>
            ) : null}
          </div>
        </DialogActions>
      </Dialog>
    </div>
  );
}
